/**
 * FuarKurallariPage.jsx — Fuar Kuralları (SEÇİLİ FUARA ÖZEL)
 * Route: /Management/Fairs/Rules   (?tab=hmax|kural|standTipi|formlar|belge|firmaBelge|kkd|talep|uyari)
 * Roller: [1,2,3]
 *
 * 2026-09-15: menüde Projeler'den Fuarlar altına taşındı ve TEK sekmeli sayfa oldu —
 * eski "Belge Kuralları" ekranı (BelgeKurallariPage scope="fuar", gömülü), yeni
 * "Talep Türleri" sekmesi (FuarTalepTurleriTab — stand_job_type_to_fuar) ve eski
 * "Proje Beyanı Uyarıları" ekranı (ProjeBeyaniUyarilariTab) buraya girdi.
 * Eski yollar (/Management/Projects/FairRules, /DocumentRules, /DeclarationWarnings)
 * buraya yönleniyor.
 *
 * Denetçi/organizatör ekranı. ÜST MENÜDEN SEÇİLİ FUARA yazılan kuralların tamamı
 * burada; dekoratörün Proje Beyanı (POST /projects/{id}/declare) bu kurallara karşı
 * yargılanıyor. Kaynak: docs/guides/FE-fuar-kural-sistemi-guide.md (rev. 2026-08-28/29).
 *
 * ⚠️ BU SAYFA GLOBAL AYAR DÜZENLEMEZ — bilinçli olarak. Global varsayılanlar ayrı bir
 *    ekranda (/Management/Projects/GlobalRules) ve menüde kasten daha az göze çarpan
 *    bir yerde duruyor: fuar kuralı düzenlemek günlük iş, global şablona dokunmak
 *    ise ileride açılacak HER fuarı etkileyen nadir bir iş. İkisi aynı ekranda bir
 *    sekme/anahtar olsaydı, yanlış kapsamda kaydetmek bir tıklık mesafede olurdu.
 *    Buradan globale yapılabilecek TEK şey onu KOPYALAMAK ("Global Varsayılanları
 *    Uygula") — okur, yazmaz.
 *
 * "Fuar Kuralları" sekmesi, "Beyan Uyarıları" sekmesinin (ProjeBeyaniUyarilariTab.jsx)
 * YERİNİ ALMIYOR ama onu büyük ölçüde gereksizleştiriyor: orası bir alanın altına
 * SERBEST METİN bir uyarı yazdırıyordu ("Ahşap standlar 24 m²'den küçük olamaz"),
 * burası aynı cümleyi backend'in ZORLADIĞI bir kurala çeviriyor — ve ihlal mesajını
 * kendisi üretiyor. Serbest metin uyarılar hâlâ kuralı olmayan şeyler için duruyor.
 *
 * Sekmeler:
 *  · Yükseklik Limitleri — fuar.fuar_h_max + salon_to_fuar.salon_h_max_tek_kat / _cift_kat
 *                          (salonun varsayılanı + fiziksel tavanı fuar_alani_salon'dan, SALT OKUNUR)
 *  · Fuar Kuralları      — fuar_kural (serbest kW modu, kullanım kuralları)
 *  · Stand Tipi Kuralları— fuar_stand_tipi_kural (tip ağacı; fuar satırları globali alan alan ezer)
 *  · Beyan Formları      — fuar_proje_beyani_form (fuara özel ek beyan formları)
 *
 * ⚠️ 2026-09-17 (backlog #52–#57):
 *    · Serbest kW dört mod: Yok / Sabit / Matematiksel (her N m² için K kW, tam bloklar) / Kademeli.
 *    · Cam/boya sabit satırları yerine katalogdan gelen "Kullanım Kuralları" listesi.
 *    · Kimlik doğrulama anahtarı KALDIRILDI — artık her fuarda zorunlu, kural değil.
 *    · Stand Tipi Kuralları sekmesi etkin ağacı gösterir (GET /kural/stand-tipi/effective):
 *      her değerin kaynağı "Bu fuar" ya da "Global". Ağaç + düzenleme modalı
 *      StandTipiKuralTree olarak dışa aktarılıyor; Global Kurallar fuar 0 ile aynısını kullanır.
 *
 * ⚠️ 2026-09-15 — YÜKSEKLİK LİMİTLERİ (backlog #25). "Tavan" terimi "limit" oldu ve fuar
 *    alanı geneli sınır KALDIRILDI. Bu sekme artık yalnızca FUARA ait sayıları düzenler:
 *      · Politika Limiti (FAIR)           — bu fuarın kendi limiti
 *      · Salon limitleri (HALL)           — bu fuarda bu salon, TEK KATLI ve ÇİFT KATLI ayrı
 *    Salonun fuar alanı seviyesindeki İZİN VERİLEN YÜKSEKLİĞİ (HALL_DEFAULT) ve FİZİKSEL TAVANI
 *    burada SALT OKUNUR — ikisi Fuar Alanları → Salonlar listesinde yönetilir.
 *    Çözüm: o kata ait salon limiti → fuar limiti → salonun varsayılanı; varsayılan ve tavan
 *    sonucu kırpar. Kat düğümü olmayan stand tipleri salon limitlerini atlar.
 *
 * ⚠️ İki yönlü kapsama: bir limiti üstünün ÜZERİNE çıkarmak 400, altındakilerin ALTINA
 *    indirmek 409'dur ve 409'un gövdesi engel olan kayıtları ADLANDIRIR — bu ekran onları
 *    listelemek zorunda, yoksa hata eyleme çevrilemez.
 *
 * ⚠️ Bu sayfanın her yerinde geçerli üç kural için bkz. fuarKuralService.js dosya
 *    başı yorumu: (1) yapılandırılmamış = zorlanmıyor, (2) null ≠ false ≠ 0,
 *    (3) en spesifik kazanır ve değerin TAMAMINI verir.
 */

import React, { useContext, useState, useEffect, useCallback, useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Container, Card, CardBody, CardHeader, Row, Col,
  Button, ButtonGroup, Badge, Table, Nav, NavItem, NavLink,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Alert, Spinner, Input, InputGroup, InputGroupText, FormGroup, Label,
} from "reactstrap";
import {
  Ruler, Layers3, Save, Trash2, Plus, RefreshCw,
  AlertTriangle, Info, Ban, Check, Zap, Pencil, Globe, ClipboardList,
  FileText, ListChecks, ChevronRight, ChevronDown, RotateCcw, ShieldCheck, Shirt,
} from "lucide-react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MainContext from "../../../Components/Contexts/MainContext";
import BelgeKurallariPage from "./BelgeKurallariPage";
import { StandTypeOptions } from "../../../Components/Projects/StandTypeAgaclari";
import DuvarKurallariAlanlari from "../../../Components/Projects/DuvarKurallariAlanlari";
// #430: the company document rules by the company's nationality (fuar_firma_belge_kural)
import FirmaBelgeKurallariKarti from "../../../Components/Fuar/FirmaBelgeKurallariKarti";
// #374: which PPE (KKD) items this fair asks for, and at which level (warns / blocks)
import KkdKurallariKarti from "../../../Components/Fuar/KkdKurallariKarti";
import FuarTalepTurleriTab from "../Fairs/FuarTalepTurleriTab";
import ProjeBeyaniUyarilariTab from "../Fairs/ProjeBeyaniUyarilariTab";
import { fetchFuarList } from "../../../slices/fuarSlice";
import {
  getStandTypes,
  getFuarDeclarationForms, attachDeclarationForm, updateDeclarationForm,
  detachDeclarationForm, uploadDeclarationFormPdf, BEYAN_FORM_TIPI,
  previewDeclarationFormImpact, applyDeclarationFormToAccepted,
} from "../../../services/projectService";
import { listTemplates } from "../../../services/freeFormService";
import {
  getFuarHMax, setSalonHMax, setFuarHMax, applyFuarHMaxToHalls,
  KAT_TIPI, KAT_TIPI_LABELS,
  getFuarKural, saveFuarKuralWithMode,
  getSerbestKwBands, validateSerbestKwBands, validateSerbestKwBlok,
  getStandTipiKuralEffective, saveStandTipiKural, deleteStandTipiKural,
  resolveInheritedStandTypeField,
  applyGlobalDefaultsToFuar,
  HMAX_SOURCE_LABELS, GLOBAL_KURAL_FUAR_ID,
  SERBEST_KW_MODE, SERBEST_KW_MODE_LABELS, SERBEST_KW_MODE_SHORT_LABELS,
  deriveSerbestKwMode, resolveFreeKw,
  STAND_TIPI_KURAL_LEVEL_LABELS,
  KURAL_SETI_SABLON_KAPSAM, listKuralSetiSablonlar, saveKuralSetiSablon, loadKuralSetiSablon,
} from "../../../services/fuarKuralService";
// Backlog #157: salon_to_fuar'a satır YARATAN tek yer — h-max ucu yalnızca zaten bağlı salonları
// döner. Bu servis dosyasında mock katmanı yok, her zaman canlı uca gider (fuarAlaniSalonService.js
// dosya başı yorumu). O yüzden aşağıda yalnızca isLive iken çağrılır — Fuar Kuralları'nın geri
// kalanı mock veriyken gerçek bir fuar_alani_id'ye karşı sorgu atmanın anlamı yok.
import { listSalonlar } from "../../../services/fuarAlaniSalonService";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

// Diğer canlı-köprü sayfalarıyla aynı liste (bkz. FirmaProjelerListPage.jsx) — bu
// fuarlar gerçek backend'e gider, kalanlar servis dosyalarındaki mock veriyi görür.
// WAS (until #398): only the two seeded test fairs ran on the real backend, every other fair fell back to mock data:
// const LIVE_TEST_FUAR_IDS = [298, 299];
// const isLiveTestFuarId = (fuarId) => LIVE_TEST_FUAR_IDS.includes(Number(fuarId));
// #398: a full-simulation test creates a NEW fair, so every real fair id is live.
const isLiveTestFuarId = (fuarId) => Number(fuarId) > 0;

const TABS = [
  { key: "hmax", get label() { return i18n.t("projeler:fuarKurallari.yukseklikLimitleri"); }, icon: Ruler },
  { key: "kural", get label() { return i18n.t("projeler:fuarKurallari.projeKurallari"); }, icon: Zap },
  { key: "standTipi", get label() { return i18n.t("projeler:fuarKurallari.standTipiKurallari"); }, icon: Layers3 },
  { key: "formlar", get label() { return i18n.t("projeler:fuarKurallari.ekFormlar"); }, icon: ClipboardList },
  { key: "belge", get label() { return i18n.t("projeler:fuarKurallari.belgeKurallari"); }, icon: FileText },
  // #430: the COMPANY document rules by the company's nationality (required / optional / not applicable / not offered), for this fair
  { key: "firmaBelge", get label() { return i18n.t("projeler:fuarKurallari.firmaBelgeKurallari"); }, icon: ShieldCheck },
  // #374: PPE (KKD) items this fair asks for: not required / warning / blocking, per catalogue item
  { key: "kkd", get label() { return i18n.t("projeler:fuarKurallari.kkd"); }, icon: Shirt },
  { key: "talep", get label() { return i18n.t("projeler:fuarKurallari.talepTurleri"); }, icon: ListChecks },
  { key: "uyari", get label() { return i18n.t("projeler:fuarKurallari.beyanUyarilari"); }, icon: AlertTriangle },
];
const TAB_KEYS = TABS.map((t) => t.key);
// Bu sayfanın kendi yükleme/bilgi kartına bağlı sekmeler. "belge", "talep" ve "uyari" kendi
// verisini kendisi çeken gömülü bileşenler — sayfanın spinner'ı onları bekletmemeli.
const KURAL_TABS = ["hmax", "kural", "standTipi", "formlar"];

const fmtM = (v) => (v == null ? "—" : `${Number(v).toFixed(2).replace(".", ",")} m`);

// Dört seviyenin rozet rengi tek yerde — açıklama kartları, salon tablosu ve
// çakışma listesi aynı renkleri kullanmak zorunda, yoksa "hangi seviye" okunmuyor.
const HMAX_SOURCE_COLOR = {
  HALL: "warning",
  FAIR: "primary",
  HALL_DEFAULT: "secondary",
  FAIRGROUND: "secondary",
  CEILING: "info",
  STAND_TYPE: "dark",
  NONE: "light",
};
const fmtM2 = (v) => (v == null ? "—" : `${Number(v).toFixed(2).replace(".", ",")} m²`);

// Boş input ('') ile 0'ı ayırmak zorundayız — 0 geçerli bir sayı, '' "temizle" demek.
const toNullableNumber = (v) => (v === "" || v == null ? null : Number(v));

/**
 * Stand tipi ağacında kök→yaprak ilerleyen seçici. Beyan modalındaki kaskadın
 * (FirmaProjelerListPage.jsx) aynısı, ama kökten başlıyor ve ARA seviyede durmaya
 * izin veriyor: kural bir dala da yazılabilir ("Özel Stand'ın tamamı 6 m") ve
 * alt tipler onu miras alır.
 */
function StandTypeCascade({ value, onChange, isLive, disabled }) {
  const { t: tx } = useTranslation("projeler");
  const [levels, setLevels] = useState([]);
  const [loading, setLoading] = useState(false);

  // Kök seviye — bir kez.
  // KURAL: setState Effect gövdesinde SENKRON çağrılmaz (react-hooks/set-state-in-effect)
  // — fetch mantığı Effect içinde tanımlanan bir async fonksiyona sarılır.
  useEffect(() => {
    let ignore = false;

    async function run() {
      setLoading(true);
      try {
        const roots = await getStandTypes(null, { forceLive: isLive });
        if (!ignore) setLevels([{ parentId: null, options: roots || [], selectedId: "" }]);
      } catch {
        if (!ignore) setLevels([]);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [isLive]);

  async function handleSelect(levelIndex, typeId) {
    const next = levels.slice(0, levelIndex + 1);
    next[levelIndex] = { ...next[levelIndex], selectedId: typeId };
    setLevels(next);
    // "(bu seviyede kalsın)" seçimi bir ÜST seviyedeki seçimi İPTAL ETMEZ — kural o
    // dala yazılır. Seçilen tip her zaman "en derin dolu seviye"dir; boşaltılan
    // seviyenin üstündeki son dolu değere geri düşülür.
    const deepest = next.reduce((acc, lvl) => (lvl.selectedId ? lvl.selectedId : acc), "");
    onChange(deepest ? Number(deepest) : null);
    if (!typeId) return;
    setLoading(true);
    try {
      const children = await getStandTypes(Number(typeId), { forceLive: isLive });
      setLevels((prev) => {
        const grown = prev.slice(0, levelIndex + 1);
        if ((children || []).length > 0) {
          grown.push({ parentId: Number(typeId), options: children, selectedId: "" });
        }
        return grown;
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Row className="g-2">
      {levels.map((lvl, i) => (
        <Col md={4} key={`${lvl.parentId ?? "root"}-${i}`}>
          <Label size="sm">{i === 0 ? tx("fuarKurallari.standTuru") : tx("fuarKurallari.altTip", { i })}</Label>
          <Input
            type="select" bsSize="sm" disabled={disabled}
            value={lvl.selectedId}
            onChange={(e) => handleSelect(i, e.target.value)}
          >
            <option value="">{i === 0 ? tx("fuarKurallari.secin") : tx("fuarKurallari.buSeviyedeKalsin")}</option>
            <StandTypeOptions options={lvl.options} />
          </Input>
        </Col>
      ))}
      {loading && <Col md="auto" className="d-flex align-items-end pb-1"><Spinner size="sm" /></Col>}
      {value != null && (
        <Col xs={12}>
          <div className="text-muted small">
            <Info size={12} className="me-1" />
            {tx("fuarKurallari.kuralBuSeviyeyeYazilirAlt")}
          </div>
        </Col>
      )}
    </Row>
  );
}

/**
 * Kullanım kuralları listesi (#53) — Fuar Kuralları ve Global Kurallar ortak.
 * Her satır: kuralın adı · "Beyanda sorulsun" · "İzinli" (kapalıysa Yasak rozeti).
 * `rules` GET /kural → kullanimKurallari; değişiklik `onChange(kod, { izinli | sorulsun })`.
 */
export function KullanimKurallariList({ rules, onChange, disabled = false, idPrefix = "kk" }) {
  const { t } = useTranslation("projeler");
  if (!rules || rules.length === 0) {
    return <div className="text-muted small">{t("fuarKurallari.tanimliAktifKullanimKuraliYok")}</div>;
  }
  return (
    <>
      {rules.map((r) => (
        <Row className="g-3 align-items-center mb-3" key={r.kod}>
          <Col md={4}>
            <div className="fw-semibold">{r.ad ?? r.kod}</div>
            {r.beyanSorusu && <div className="text-muted small">{t("fuarKurallari.beyan", { beyanSorusu: r.beyanSorusu })}</div>}
          </Col>
          <Col md={8} className="d-flex flex-wrap gap-4">
            <FormGroup switch className="mb-0">
              <Input
                type="switch" role="switch" id={`${idPrefix}-${r.kod}-ask`}
                checked={Boolean(r.sorulsun)} disabled={disabled}
                onChange={(e) => onChange(r.kod, { sorulsun: e.target.checked })}
              />
              <Label check for={`${idPrefix}-${r.kod}-ask`}>{t("fuarKurallari.beyandaSorulsun")}</Label>
            </FormGroup>
            <FormGroup switch className="mb-0">
              <Input
                type="switch" role="switch" id={`${idPrefix}-${r.kod}-allow`}
                checked={Boolean(r.izinli)} disabled={disabled}
                onChange={(e) => onChange(r.kod, { izinli: e.target.checked })}
              />
              <Label check for={`${idPrefix}-${r.kod}-allow`}>
                {t("fuarKurallari.izinli")}
                {!r.izinli && (
                  <Badge color="danger" className="ms-2" title={r.yasakMesaji ?? undefined}>{t("fuarKurallari.yasak")}</Badge>
                )}
              </Label>
            </FormGroup>
          </Col>
        </Row>
      ))}
    </>
  );
}

// ─── Stand tipi kural ağacı (#55/#57) ─────────────────────────────────────────
// Kaynak rozetleri: "Bu fuar" (FUAR) / "Global" (GLOBAL). null = hiçbir yerde tanımlı değil.
const LEVEL_BADGE = {
  FUAR: { color: "primary-subtle", className: "text-primary" },
  GLOBAL: { color: "dark-subtle", className: "text-body" },
};
const EMPTY_RULE_FORM = { standTypeId: null, yasak: "", minM2: "", maxM2: "", hMax: "" };

const describeRuleValue = (field, value) => {
  if (value == null) return "yok";
  // WAS: if (field === "yasak") return value ? "Yasak" : "İzinli";
  if (field === "yasak") return value ? i18n.t("projeler:fuarKurallari.yasak") : i18n.t("projeler:fuarKurallari.izinli"); // #349
  return field === "hMax" ? fmtM(value) : fmtM2(value);
};

// "Global ← Özel Stand" — başka bir tipten geliyorsa oku ekler.
const describeRuleSource = (level, fromId, fromName, selfId) => {
  if (!level) return null;
  const label = STAND_TIPI_KURAL_LEVEL_LABELS[level] ?? level;
  return fromId != null && Number(fromId) !== Number(selfId)
    ? `${label} ← ${fromName ?? `#${fromId}`}`
    : label;
};

function LevelSource({ level, fromId, fromName, selfId }) {
  if (!level) return null;
  const style = LEVEL_BADGE[level] ?? { color: "light", className: "text-dark" };
  const fromOther = fromId != null && Number(fromId) !== Number(selfId);
  return (
    <>
      <Badge color={style.color} className={`${style.className} fw-normal ms-1`}>
        {STAND_TIPI_KURAL_LEVEL_LABELS[level] ?? level}
      </Badge>
      {fromOther && <span className="text-muted small ms-1">← {fromName ?? `#${fromId}`}</span>}
    </>
  );
}

function EffectiveCell({ display, level, fromId, fromName, selfId }) {
  if (display == null) return <span className="text-muted">—</span>;
  return (
    <>
      <span className={level === "FUAR" ? "fw-semibold" : ""}>{display}</span>
      <LevelSource level={level} fromId={fromId} fromName={fromName} selfId={selfId} />
    </>
  );
}

/** Modalda alanın altındaki satır: devralınan değer + kaynağı, doluysa "Devralınan değere dön". */
function InheritHint({ field, inherited, selfId, onReset }) {
  const { t } = useTranslation("projeler");
  const src = describeRuleSource(
    inherited?.level, inherited?.fromStandTypeId, inherited?.fromStandTypeName, selfId
  );
  return (
    <div className="d-flex align-items-center justify-content-between flex-wrap gap-1 small mt-1">
      <span className="text-muted">
        {t("fuarKurallari.devralinan")}{" "}{describeRuleValue(field, inherited?.value ?? null)}{src ? ` · ${src}` : ""}
      </span>
      {onReset && (
        <Button color="link" size="sm" className="p-0 small" onClick={onReset}>
          <RotateCcw size={11} className="me-1" />{t("fuarKurallari.devralinanDegereDon")}
        </Button>
      )}
    </div>
  );
}

/**
 * Stand tipi kurallarının ETKİN ağacı + düzenleme/kaldırma modalları.
 * Fuar Kuralları (fuarId = seçili fuar) ve Global Kurallar (fuarId = 0) ortak kullanır.
 *
 * Düzenlenen katman: fuar sayfasında `fuarKural`, fuar 0'da `globalKural`. PUT o satırın TAM
 * değiştirmesi (null = devral), DELETE satırı kaldırır (her alan devralınana döner).
 *
 * @param tree       getStandTipiKuralEffective çıktısı (derinlik öncelikli)
 * @param runAction  sayfanın (fn, okMsg) → Promise<boolean> sarmalayıcısı — hata/başarı mesajı
 *                   ve yeniden yükleme sayfada kalır
 */
export function StandTipiKuralTree({
  fuarId, forceLive = false, tree = [], actionLoading = false, runAction,
  accent = "primary", footer = null,
}) {
  const { t } = useTranslation("projeler");
  const isGlobal = Number(fuarId) === GLOBAL_KURAL_FUAR_ID;
  const [collapsed, setCollapsed] = useState(() => new Set());
  const [ruleModal, setRuleModal] = useState(false);
  const [ruleEditing, setRuleEditing] = useState(null); // null = yeni (tip kaskaddan seçilir)
  const [ruleForm, setRuleForm] = useState(EMPTY_RULE_FORM);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const ownOf = useCallback(
    (row) => (row ? (isGlobal ? row.globalKural : row.fuarKural) ?? null : null),
    [isGlobal]
  );
  const byId = useMemo(() => new Map(tree.map((n) => [Number(n.standTypeId), n])), [tree]);
  const parentIds = useMemo(() => {
    const s = new Set();
    tree.forEach((n) => { if (n.parentId != null) s.add(Number(n.parentId)); });
    return s;
  }, [tree]);

  // Kapalı bir atası olan satır gizlenir.
  const visibleRows = tree.filter((n) => {
    const guard = new Set();
    let p = n.parentId != null ? byId.get(Number(n.parentId)) : null;
    while (p && !guard.has(Number(p.standTypeId))) {
      if (collapsed.has(Number(p.standTypeId))) return false;
      guard.add(Number(p.standTypeId));
      p = p.parentId != null ? byId.get(Number(p.parentId)) : null;
    }
    return true;
  });
  const overrideCount = tree.filter((n) => ownOf(n) != null).length;

  const toggle = (id) => setCollapsed((prev) => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id); else next.add(id);
    return next;
  });

  const formFromRow = (standTypeId, own) => ({
    standTypeId,
    // Tri-state: '' miras · 'true' yasak · 'false' AÇIKÇA izinli (üstteki yasağı kaldırır).
    yasak: own?.yasak == null ? "" : String(own.yasak),
    minM2: own?.minM2 ?? "",
    maxM2: own?.maxM2 ?? "",
    hMax: own?.hMax ?? "",
  });

  function openNew() {
    setRuleEditing(null);
    setRuleForm(EMPTY_RULE_FORM);
    setRuleModal(true);
  }
  function openEdit(row) {
    setRuleEditing(row);
    setRuleForm(formFromRow(Number(row.standTypeId), ownOf(row)));
    setRuleModal(true);
  }
  // Yeni kuralda tip seçilince o tipin mevcut satırıyla doldur — PUT tam değiştirme,
  // boş formla kaydetmek var olan değerleri sessizce silerdi.
  function handleCascade(id) {
    if (id == null) { setRuleForm(EMPTY_RULE_FORM); return; }
    setRuleForm(formFromRow(id, ownOf(byId.get(Number(id)))));
  }
  const setField = (field, value) => setRuleForm((f) => ({ ...f, [field]: value }));
  const closeModal = () => { if (!actionLoading) setRuleModal(false); };

  const targetRow = ruleEditing ?? (ruleForm.standTypeId != null ? byId.get(Number(ruleForm.standTypeId)) : null);
  const targetOwn = ownOf(targetRow);
  const inherited = (field) => (targetRow
    ? resolveInheritedStandTypeField(tree, targetRow.standTypeId, field, { fuarId })
    : null);
  const inh = {
    yasak: inherited("yasak"), minM2: inherited("minM2"), maxM2: inherited("maxM2"), hMax: inherited("hMax"),
  };

  // Backend de 400 ile yakalıyor ama kullanıcıya kaydetmeden ÖNCE söylemek daha iyi:
  // hiçbir standın sağlayamayacağı bir kural, sonradan HER beyanı reddeder.
  const rangeInvalid =
    ruleForm.minM2 !== "" && ruleForm.maxM2 !== "" && Number(ruleForm.minM2) > Number(ruleForm.maxM2);
  const allEmpty = ["yasak", "minM2", "maxM2", "hMax"].every((k) => ruleForm[k] === "" || ruleForm[k] == null);

  async function handleSave() {
    if (!ruleForm.standTypeId || rangeInvalid) return;
    // Hepsi boş = satıra gerek yok: varsa kaldır, yoksa yazma (tamamı null satır çöp olurdu).
    if (allEmpty) {
      if (!targetOwn) { setRuleModal(false); return; }
      const ok = await runAction(
        () => deleteStandTipiKural(fuarId, ruleForm.standTypeId, { forceLive }),
        t("fuarKurallari.tumAlanlarBosSatirKaldirildi")
      );
      if (ok) setRuleModal(false);
      return;
    }
    const ok = await runAction(
      () => saveStandTipiKural(fuarId, ruleForm.standTypeId, {
        yasak: ruleForm.yasak === "" ? null : ruleForm.yasak === "true",
        minM2: ruleForm.minM2, maxM2: ruleForm.maxM2, hMax: ruleForm.hMax,
      }, { forceLive }),
      isGlobal
        ? t("fuarKurallari.globalStandTipiKuraliKaydedildi")
        : t("fuarKurallari.standTipiKuraliKaydedildi")
    );
    if (ok) setRuleModal(false);
  }

  async function handleDelete() {
    if (!deleteTarget) return;
    const ok = await runAction(
      () => deleteStandTipiKural(fuarId, deleteTarget.standTypeId, { forceLive }),
      isGlobal
        ? t("fuarKurallari.globalKuralKaldirildiTipUst")
        : t("fuarKurallari.gecersizKilmalarKaldirildiBuTip")
    );
    if (ok) setDeleteTarget(null);
  }

  const targetName = targetRow?.standTypeName ?? (targetRow ? `#${targetRow.standTypeId}` : null);

  return (
    <>
      <Card>
        <CardHeader className="d-flex align-items-center gap-2 flex-wrap">
          <h6 className="card-title mb-0 flex-grow-1">
            {t("fuarKurallari.standTipiKurallari")}{" "}<Badge color="light" className="text-dark ms-1">{tree.length}</Badge>
            {overrideCount > 0 && (
              <Badge color={`${accent}-subtle`} className={`text-${accent} ms-1`}>
                {overrideCount} {isGlobal ? t("fuarKurallari.tanimli") : t("fuarKurallari.gecersizKilma")}
              </Badge>
            )}
          </h6>
          {parentIds.size > 0 && (
            <>
              <Button color="light" size="sm" className="border" disabled={collapsed.size === 0}
                onClick={() => setCollapsed(new Set())}>
                {t("fuarKurallari.tumunuAc")}
              </Button>
              <Button color="light" size="sm" className="border"
                onClick={() => setCollapsed(new Set(parentIds))}>
                {t("fuarKurallari.tumunuKapat")}
              </Button>
            </>
          )}
          <Button color={accent} size="sm" onClick={openNew}>
            <Plus size={14} className="me-1" />{t("fuarKurallari.kuralEkle")}
          </Button>
        </CardHeader>
        <CardBody className="p-0">
          {tree.length === 0 ? (
            <div className="text-muted text-center py-4">{t("fuarKurallari.standTipiBulunamadi")}</div>
          ) : (
            <div className="table-responsive">
              <Table className="align-middle table-nowrap table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="ps-3">{t("fuarKurallari.standTipi")}</th>
                    <th>{t("fuarKurallari.durum")}</th>
                    <th>{t("fuarKurallari.minAlan")}</th>
                    {/* Maks. Alan backlog #90 ile gizlendi — veri (fuar_stand_tipi_kural.max_m2)
                        ve payload'da hâlâ var, yalnızca burada gösterilmiyor/düzenlenemiyor. */}
                    <th>{t("fuarKurallari.hMax")}</th>
                    <th style={{ width: 100 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {visibleRows.map((r) => {
                    const id = Number(r.standTypeId);
                    const own = ownOf(r);
                    const expandable = parentIds.has(id);
                    const isCollapsed = collapsed.has(id);
                    return (
                      // Kendi satırı olan tipler solda renkli bir çizgiyle işaretlenir.
                      <tr key={id} style={own ? { boxShadow: `inset 3px 0 0 var(--vz-${accent})` } : undefined}>
                        <td className="ps-3">
                          <div className="d-flex align-items-center" style={{ paddingLeft: (Number(r.depth) || 0) * 20 }}>
                            {expandable ? (
                              <Button
                                color="link" size="sm" className="p-0 me-1 text-body"
                                onClick={() => toggle(id)}
                                title={isCollapsed ? t("fuarKurallari.altTipleriGoster") : t("fuarKurallari.altTipleriGizle")}
                              >
                                {isCollapsed ? <ChevronRight size={14} /> : <ChevronDown size={14} />}
                              </Button>
                            ) : (
                              <span className="d-inline-block me-1" style={{ width: 14 }} />
                            )}
                            <span className={own ? "fw-semibold" : ""}>{r.standTypeName ?? `#${id}`}</span>
                            {own && (
                              <Badge color={`${accent}-subtle`} className={`text-${accent} fw-normal ms-2`}>
                                {isGlobal ? t("fuarKurallari.tanimli2") : t("fuarKurallari.buFuaraOzel")}
                              </Badge>
                            )}
                          </div>
                        </td>
                        <td>
                          {/* Yasak / açıkça izinli (seviyesi var) / kural yok — üç ayrı durum. */}
                          {r.forbidden && <Badge color="danger"><Ban size={11} className="me-1" />{t("fuarKurallari.yasak")}</Badge>}
                          {!r.forbidden && r.forbiddenLevel && (
                            <Badge color="success-subtle" className="text-success"><Check size={11} className="me-1" />{t("fuarKurallari.izinli")}</Badge>
                          )}
                          {!r.forbidden && !r.forbiddenLevel && <span className="text-muted small">{t("fuarKurallari.izinli")}</span>}
                          <LevelSource
                            level={r.forbiddenLevel} fromId={r.forbiddenFromStandTypeId}
                            fromName={r.forbiddenFromStandTypeName} selfId={id}
                          />
                        </td>
                        <td>
                          <EffectiveCell
                            display={r.minM2 == null ? null : fmtM2(r.minM2)} level={r.minM2Level}
                            fromId={r.minM2FromStandTypeId} fromName={r.minM2FromStandTypeName} selfId={id}
                          />
                        </td>
                        <td>
                          <EffectiveCell
                            display={r.hMax == null ? null : fmtM(r.hMax)} level={r.hMaxLevel}
                            fromId={r.hMaxFromStandTypeId} fromName={r.hMaxFromStandTypeName} selfId={id}
                          />
                        </td>
                        <td className="text-end pe-3">
                          <Button color="link" size="sm" className="text-body p-1" onClick={() => openEdit(r)} title={t("common:duzenle")}>
                            <Pencil size={14} />
                          </Button>
                          {own && (
                            <Button
                              color="link" size="sm" className="text-danger p-1"
                              onClick={() => setDeleteTarget(r)}
                              title={isGlobal ? t("fuarKurallari.globalKuraliKaldir") : t("fuarKurallari.tumGecersizKilmalariKaldir")}
                            >
                              <Trash2 size={14} />
                            </Button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </CardBody>
        <div className="card-footer text-muted small">
          {footer ?? (isGlobal
            ? t("fuarKurallari.herAlanOnceTipinKendisinden")
            : t("fuarKurallari.herAlanOnceBuFuarin"))}
        </div>
      </Card>

      {/* ─── Stand tipi kuralı ekle/düzenle ─── */}
      <Modal isOpen={ruleModal} toggle={closeModal} centered size="lg">
        <ModalHeader toggle={closeModal}>
          {ruleEditing
            ? `${isGlobal ? t("fuarKurallari.globalKural") : t("fuarKurallari.standTipiKurali")} — ${targetName}`
            : isGlobal ? t("fuarKurallari.globalStandTipiKurali") : t("fuarKurallari.standTipiKurali")}
        </ModalHeader>
        <ModalBody>
          {!ruleEditing && (
            <div className="mb-3">
              <StandTypeCascade
                value={ruleForm.standTypeId}
                onChange={handleCascade}
                isLive={forceLive}
                disabled={actionLoading}
              />
            </div>
          )}
          {targetOwn && !ruleEditing && (
            <Alert color="info" className="small py-2">
              <Info size={13} className="me-1" />
              {t("fuarKurallari.icin", { targetName })}{" "}{isGlobal ? t("fuarKurallari.global") : t("fuarKurallari.buFuaraOzel2")}{" "}{t("fuarKurallari.birSatirZatenVarForm")}
            </Alert>
          )}
          <Row className="g-3">
            <Col md={6}>
              <Label size="sm">{t("fuarKurallari.durum")}</Label>
              <Input
                type="select" bsSize="sm" value={ruleForm.yasak}
                onChange={(e) => setField("yasak", e.target.value)}
              >
                <option value="">
                  {t("fuarKurallari.mirasAl")}{targetRow ? t("fuarKurallari.suAn", { v: inh.yasak?.value === true ? t("fuarKurallari.yasak") : t("fuarKurallari.izinli") }) : ""}
                </option>
                <option value="true">{t("fuarKurallari.yasak")}</option>
                <option value="false">{t("fuarKurallari.acikcaIzinliUstYasagiKaldirir")}</option>
              </Input>
              {targetRow && (
                <InheritHint
                  field="yasak" inherited={inh.yasak} selfId={targetRow.standTypeId}
                  onReset={ruleForm.yasak !== "" ? () => setField("yasak", "") : null}
                />
              )}
            </Col>
            <Col md={6} />
            {/* Maks. Alan (maxM2) backlog #90 ile formdan gizlendi. Alan hâlâ ruleForm'da ve
                handleSave'in gönderdiği payload'da var — formFromRow onu değiştirmeden önceden
                doldurduğu için (own?.maxM2 ?? "") burada düzenlenemediği için PUT var olan
                değeri sessizce silmez. */}
            {[
              ["minM2", "Min. alan (m²)"],
              ["hMax", "H Max (m)"],
            ].map(([field, label]) => (
              <Col md={6} key={field}>
                <Label size="sm">{label}</Label>
                <Input
                  type="number" min="0" step="0.1" bsSize="sm"
                  placeholder={inh[field]?.value != null ? t("fuarKurallari.devral", { describeRuleValue: describeRuleValue(field, inh[field].value) }) : t("fuarKurallari.devral2")}
                  value={ruleForm[field]}
                  onChange={(e) => setField(field, e.target.value)}
                />
                {targetRow && (
                  <InheritHint
                    field={field} inherited={inh[field]} selfId={targetRow.standTypeId}
                    onReset={ruleForm[field] !== "" && ruleForm[field] != null ? () => setField(field, "") : null}
                  />
                )}
              </Col>
            ))}
          </Row>
          {rangeInvalid && <div className="text-danger small mt-2">{t("fuarKurallari.minAlanMaksAlandanBuyuk")}</div>}
          {/* 0 backend'de reddediliyor; temizlemek = boşaltmak. */}
          <div className="text-muted small mt-3">
            {t("fuarKurallari.bosAlanDevral")}{isGlobal ? t("fuarKurallari.ustTiplerden") : t("fuarKurallari.onceBuFuarinUstTiplerinden")}{t("fuarKurallari.temizlemekIcinBosaltin0Yazmayin")}
          </div>
        </ModalBody>
        <ModalFooter>
          {targetOwn && (
            <Button
              color="link" className="text-danger me-auto" disabled={actionLoading}
              onClick={() => { setRuleModal(false); setDeleteTarget(targetRow); }}
            >
              <RotateCcw size={14} className="me-1" />
              {isGlobal ? t("fuarKurallari.globalKuraliKaldir") : t("fuarKurallari.tumGecersizKilmalariKaldir")}
            </Button>
          )}
          <Button color="light" onClick={() => setRuleModal(false)} disabled={actionLoading}>{t("fuarKurallari.vazgec")}</Button>
          <Button color={accent} onClick={handleSave} disabled={actionLoading || !ruleForm.standTypeId || rangeInvalid}>
            {actionLoading ? <Spinner size="sm" className="me-1" /> : <Save size={14} className="me-1" />}{t("common:kaydet")}
          </Button>
        </ModalFooter>
      </Modal>

      {/* ─── Satırı kaldır (DELETE) ─── */}
      <Modal isOpen={Boolean(deleteTarget)} toggle={() => !actionLoading && setDeleteTarget(null)} centered>
        <ModalHeader toggle={() => !actionLoading && setDeleteTarget(null)}>
          {isGlobal ? t("fuarKurallari.globalKuraliKaldir2") : t("fuarKurallari.gecersizKilmalariKaldir")}
        </ModalHeader>
        <ModalBody>
          <span className="fw-semibold">{deleteTarget?.standTypeName ?? `#${deleteTarget?.standTypeId}`}</span>{" "}
          {isGlobal
            ? t("fuarKurallari.icinGlobalKuralSilinecekTip")
            : t("fuarKurallari.icinBuFuaraOzelTum")}
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setDeleteTarget(null)} disabled={actionLoading}>{t("fuarKurallari.vazgec")}</Button>
          <Button color="danger" onClick={handleDelete} disabled={actionLoading}>
            {actionLoading ? <Spinner size="sm" className="me-1" /> : <Trash2 size={14} className="me-1" />}{t("fuarKurallari.kaldir")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default function FuarKurallariPage() {
  const { t: tx } = useTranslation("projeler");
  const { selectedFuarId } = useContext(MainContext);
  const isLive = isLiveTestFuarId(selectedFuarId);
  const dispatch = useDispatch();
  const fuarList = useSelector((s) => s.fuar?.list || []);
  const selectedFuarName = fuarList.find((f) => Number(f.fuarId) === Number(selectedFuarId))?.fuarName;

  // Sekme URL'de (?tab=) — eski /Management/Projects/DocumentRules yolu buraya
  // ?tab=belge ile yönleniyor, sekme linki paylaşılabilir kalsın.
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab = TAB_KEYS.includes(tabParam) ? tabParam : "hmax";
  const setActiveTab = useCallback((key) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("tab", key);
      return next;
    }, { replace: true });
  }, [setSearchParams]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [reloadToken, setReloadToken] = useState(0);

  // Sekme 1 — yükseklik limitleri (fuar limiti + salonun tek/çift katlı limitleri)
  const [hmax, setHmax] = useState(null);
  const [hallLimitInputs, setHallLimitInputs] = useState({});   // salonToFuarId -> { tek, cift } (string)
  const [fairLimitInput, setFairLimitInput] = useState("");     // fuar.fuar_h_max
  const [ceilingConflict, setCeilingConflict] = useState(null); // 409 gövdesindeki engel listesi
  // Backlog #48/#49: hangi kat için "Fuar limitini tüm salonlara uygula" onay modalı açık —
  // null | KAT_TIPI.TEK_KAT | KAT_TIPI.CIFT_KAT.
  const [applyModalKat, setApplyModalKat] = useState(null);
  // Backlog #157: fuar alanına kayıtlı ama bu fuara henüz BAĞLANMAMIŞ salonlar — h-max ucu bunları
  // hiç döndürmez (salon_to_fuar satırı yok ki dönsün). Yalnızca canlı test fuarlarında çekilir.
  const [unlinkedHalls, setUnlinkedHalls] = useState([]);
  const [unlinkedLoading, setUnlinkedLoading] = useState(false);

  // Sekme 2 — fuar_kural + serbest kW kademeleri + kullanım kuralları
  // 2026-09-17: cam/boya alanları ve kimlik doğrulama anahtarı formdan çıktı (#53/#54).
  const [kural, setKural] = useState(null);
  const [kuralForm, setKuralForm] = useState({ serbestKw: "", serbestKwBlokKw: "", serbestKwBlokM2: "", komsuDuvarFarkM: "", minAciklikYuzde: "" });
  const [kwMode, setKwMode] = useState(SERBEST_KW_MODE.NONE);
  const [bands, setBands] = useState([]);
  const [usageRules, setUsageRules] = useState([]); // kullanimKurallari — PUT'ta otoriter

  // Sekme 3 — etkin stand tipi ağacı (fuar satırları + global miras). Düzenleme
  // modalları StandTipiKuralTree'nin içinde.
  const [typeTree, setTypeTree] = useState([]);

  // Sekme 4 — fuar_proje_beyani_form
  const [beyanFormlari, setBeyanFormlari] = useState([]);
  const [standTemplates, setStandTemplates] = useState([]);
  const [formModal, setFormModal] = useState(false);
  const [formDraft, setFormDraft] = useState({ formTipi: 1, formRef: "", zorunlu: false, sira: 1 });
  // Backlog #92/#93: formTipi 3 (PDF) — seçilen dosya, attach'tan önce ayrıca yüklenir.
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfUploading, setPdfUploading] = useState(false);

  // Backlog #94/#95: "Tüm Beyanlara Uygula" — bu formu henüz karşılamayan, zaten kabul edilmiş
  // beyanların sistem atamasını geri alır. applyFormResult dolduğunda modal sonucu gösterir,
  // kapanmaz — #95'in istediği "sonuç özeti" budur.
  const [applyFormTarget, setApplyFormTarget] = useState(null);
  const [applyFormModal, setApplyFormModal] = useState(false);
  const [applyFormPreview, setApplyFormPreview] = useState(null);
  const [applyFormPreviewLoading, setApplyFormPreviewLoading] = useState(false);
  const [applyFormResult, setApplyFormResult] = useState(null);
  const [applyFormSebep, setApplyFormSebep] = useState("");

  // Global şablonu uygula
  const [globalModal, setGlobalModal] = useState(false);

  // Backlog #89: named rule-set templates — "kural" tabında Proje Kural Seti, "standTipi"
  // tabında Stand Tipi Kuralları kapsamı. Aynı iki modal her iki sekmede de kullanılıyor.
  const [saveSablonModal, setSaveSablonModal] = useState(false);
  const [sablonAdi, setSablonAdi] = useState("");
  const [loadSablonModal, setLoadSablonModal] = useState(false);
  const [sablonlar, setSablonlar] = useState([]);
  const [sablonlarLoading, setSablonlarLoading] = useState(false);
  const [selectedSablonId, setSelectedSablonId] = useState("");

  useEffect(() => { document.title = i18n.t("projeler:fuarKurallari.fuarKurallariFds"); }, []);
  // Seçili fuarın ADI için — liste store'da yoksa bir kez çek (tek istek, düz dizi).
  useEffect(() => {
    if (fuarList.length === 0) dispatch(fetchFuarList()); // WAS (until #332): fetchFuarList({ languageId: 1 })
  }, [dispatch, fuarList.length]);

  useEffect(() => {
    if (!successMsg) return undefined;
    const t = setTimeout(() => setSuccessMsg(null), 4500);
    return () => clearTimeout(t);
  }, [successMsg]);

  // KURAL: fetch mantığı Effect içindeki async fonksiyonda tanımlanır, üst seviye
  // paylaşılan bir fonksiyon olarak DEĞİL — aksi halde react-hooks/set-state-in-effect
  // ihlali oluşur. Kaydetme/silme işlemleri reloadToken'ı artırarak yeniden çekmeyi
  // tetikler.
  useEffect(() => {
    if (!selectedFuarId) return undefined;
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const [k, bandRows] = await Promise.all([
          getFuarKural(selectedFuarId, { forceLive: isLive }),
          getSerbestKwBands(selectedFuarId, { forceLive: isLive }),
        ]);
        if (ignore) return;
        setKural(k);
        setKuralForm({
          serbestKw: k?.serbestKw ?? "",
          serbestKwBlokKw: k?.serbestKwBlokKw ?? "",
          serbestKwBlokM2: k?.serbestKwBlokM2 ?? "",
          komsuDuvarFarkM: k?.komsuDuvarFarkM ?? "",
          minAciklikYuzde: k?.minAciklikYuzde ?? "",
        });
        setUsageRules((k?.kullanimKurallari || []).map((r) => ({ ...r })));
        setBands(bandRows || []);
        // Mod veriden TÜRETİLİR, saklanmaz — editörü buna göre çiziyoruz.
        setKwMode(deriveSerbestKwMode({ ...k, serbestKwKademeleri: bandRows }));

        // Etkin stand tipi ağacı — yeni uç; patlarsa diğer sekmeler yine çalışmalı.
        try {
          const tree = await getStandTipiKuralEffective(selectedFuarId, { forceLive: isLive });
          if (!ignore) setTypeTree(tree || []);
        } catch (e) { if (!ignore) { setTypeTree([]); setError(e.message); } }

        // Yükseklik limitleri — patlarsa sayfa yine de render edilmeli.
        try {
          const h = await getFuarHMax(selectedFuarId, { forceLive: isLive });
          if (!ignore) {
            setHmax(h);
            const limits = {};
            (h?.halls || []).forEach((s) => {
              if (s.salonToFuarId == null) return;
              limits[s.salonToFuarId] = {
                tek: s.salonHMaxTekKat == null ? "" : String(s.salonHMaxTekKat),
                cift: s.salonHMaxCiftKat == null ? "" : String(s.salonHMaxCiftKat),
              };
            });
            setHallLimitInputs(limits);
            setFairLimitInput(h?.fuarHMax == null ? "" : String(h.fuarHMax));
          }
        } catch (e) { if (!ignore) { setHmax(null); setError(e.message); } }

        // Beyan formları — ayrı try: tablo yoksa 500 döner, sayfanın kalanı yaşasın.
        try {
          const forms = await getFuarDeclarationForms(selectedFuarId, {
            includeInactive: true, forceLive: isLive,
          });
          if (!ignore) setBeyanFormlari(forms || []);
        } catch { if (!ignore) setBeyanFormlari([]); }
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [selectedFuarId, isLive, reloadToken]);

  // Serbest form şablonları — SADECE STAND hedefliler beyana takılabilir, süzme
  // bize ait (backend'in reddi 200 + result:false ile gelir, yakalanması zordur).
  useEffect(() => {
    if (activeTab !== "formlar") return undefined;
    let ignore = false;
    async function run() {
      try {
        const res = await listTemplates({ targetEntityType: "STAND", limit: 200 });
        // GET /freeform/templates gövdesi {total, page, limit, records:[...]} döner — data/items
        // hiçbir zaman yoktu, bu yüzden liste hep boştu (backlog #91).
        const rows = Array.isArray(res) ? res : res?.records ?? [];
        if (!ignore) setStandTemplates(rows.filter((t) => t.targetEntityType === "STAND"));
      } catch { if (!ignore) setStandTemplates([]); }
    }
    run();
    return () => { ignore = true; };
  }, [activeTab]);

  const refresh = useCallback(() => setReloadToken((t) => t + 1), []);

  // Backlog #157: hmax yenilendikçe (kaydetme sonrası refresh() dahil) bağlanmamış salon
  // listesini de tazeler. fuarAlaniSalonService'te mock yok — bu yüzden yalnızca isLive.
  useEffect(() => {
    const fuarAlaniId = hmax?.fuarAlaniId;
    let ignore = false;
    (async () => {
      if (!isLive || fuarAlaniId == null) {
        if (!ignore) setUnlinkedHalls([]);
        return;
      }
      setUnlinkedLoading(true);
      try {
        const registered = await listSalonlar(fuarAlaniId);
        if (ignore) return;
        const linkedIds = new Set((hmax?.halls ?? []).map((h) => Number(h.salonId)));
        setUnlinkedHalls(registered.filter((s) => !linkedIds.has(Number(s.salonId))));
      } catch {
        if (!ignore) setUnlinkedHalls([]);
      } finally {
        if (!ignore) setUnlinkedLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, [isLive, hmax]);

  async function runAction(fn, okMsg) {
    setActionLoading(true);
    setError(null);
    setCeilingConflict(null);
    try {
      const out = await fn();
      refresh();
      setSuccessMsg(typeof okMsg === "function" ? okMsg(out) : okMsg);
      return true;
    } catch (e) {
      setError(e.message);
      if (e.conflicts) setCeilingConflict(e.conflicts);
      return false;
    } finally {
      setActionLoading(false);
    }
  }

  // ─── Sekme 1 aksiyonları ────────────────────────────────────────────────────
  // Yalnızca DEĞİŞEN kat gönderilir — gönderilmeyen kat backend'de olduğu gibi kalır.
  const handleSaveHallLimit = (hall) => {
    const input = hallLimitInputs[hall.salonToFuarId] ?? { tek: "", cift: "" };
    const limits = {};
    if (input.tek !== (hall.salonHMaxTekKat == null ? "" : String(hall.salonHMaxTekKat))) {
      limits.tekKatHMax = toNullableNumber(input.tek);
    }
    if (input.cift !== (hall.salonHMaxCiftKat == null ? "" : String(hall.salonHMaxCiftKat))) {
      limits.ciftKatHMax = toNullableNumber(input.cift);
    }
    return runAction(
      () => setSalonHMax(hall.salonToFuarId, limits, { forceLive: isLive }),
      `${hall.salonName ?? "Salon"} limitleri kaydedildi.`
    );
  };

  // Boş input = temizle (null) — servis anahtarı gövdeye HER ZAMAN koyar, çünkü atlamak 400.
  const handleSaveFairLimit = () =>
    runAction(
      () => setFuarHMax(selectedFuarId, toNullableNumber(fairLimitInput), { forceLive: isLive }),
      toNullableNumber(fairLimitInput) == null
        ? tx("fuarKurallari.fuarLimitiTemizlendiSalonlarinVarsayilanlari")
        : "Fuar limiti kaydedildi."
    );

  // Backlog #48: fuar limitini bu kat için fuardaki HER salona toplu yazar — zaten kendi değeri
  // olan salonlar da EZİLİR. Salonun kendi fuar alanı sınırını (izin verilen/tavan) aşan salonlar
  // atlanır ve isimleriyle bildirilir; hiçbir şey bloklanmaz. handleApplyToHalls onay modalından
  // (aşağıda) çağrılır, doğrudan buton onClick'inden değil.
  const handleApplyToHalls = (kat) =>
    runAction(
      () => applyFuarHMaxToHalls(selectedFuarId, kat, { forceLive: isLive }),
      (out) => {
        const applied = out?.appliedCount ?? 0;
        const skipped = out?.skippedHalls ?? [];
        const base = tx("fuarKurallari.limitiSalonaUygulandi", { v: KAT_TIPI_LABELS[kat] ?? kat, applied });
        return skipped.length
          ? tx("fuarKurallari.salonKendiSiniriniAstigiIcin", { base, length: skipped.length })
            + skipped.map((s) => s.salonName ?? `Salon #${s.salonId}`).join(", ") + "."
          : base;
      }
    ).finally(() => setApplyModalKat(null));


  // ─── Sekme 2 aksiyonları ────────────────────────────────────────────────────
  function updateKural(field, value) {
    setKuralForm((f) => ({ ...f, [field]: value }));
  }

  const updateUsageRule = (kod, patch) =>
    setUsageRules((rows) => rows.map((r) => (r.kod === kod ? { ...r, ...patch } : r)));

  const bandErrors = kwMode === SERBEST_KW_MODE.BANDS ? validateSerbestKwBands(bands) : [];
  const blokErrors = kwMode === SERBEST_KW_MODE.BLOCK
    ? validateSerbestKwBlok(kuralForm.serbestKwBlokKw, kuralForm.serbestKwBlokM2)
    : [];
  // Hiçbir şey yazılmamışken "ikisi de zorunlu" diye bağırmayalım — Kaydet zaten kapalı.
  const blokTouched = kuralForm.serbestKwBlokKw !== "" || kuralForm.serbestKwBlokM2 !== "";

  /**
   * ⚠️ SIRA ÖNEMLİ ve tek bir "Kaydet" düğmesinin arkasında iki uç var: kademeye geçerken
   *    önce PUT /kural (sabit + blok null), sonra kademeler; diğer modlarda önce kademeler [],
   *    sonra PUT /kural. Sıra servisteki saveFuarKuralWithMode'da — kopyalama da onu kullanıyor.
   * `kullanimKurallari` OTORİTER: ekrandaki her kural gönderilir.
   */
  const handleSaveKural = () => {
    if (bandErrors.length || blokErrors.length) return Promise.resolve(false);
    return runAction(
      () => saveFuarKuralWithMode(
        selectedFuarId,
        kwMode,
        {
          ...kuralForm,
          kullanimKurallari: usageRules.map((r) => ({ kod: r.kod, izinli: r.izinli, sorulsun: r.sorulsun })),
        },
        bands,
        { forceLive: isLive }
      ),
      tx("fuarKurallari.fuarKurallariKaydedildi")
    );
  };

  const addBand = () => setBands((b) => [...b, { minM2: "", maxM2: "", serbestKw: "" }]);
  const updateBand = (i, field, value) =>
    setBands((b) => b.map((row, idx) => (idx === i ? { ...row, [field]: value } : row)));
  const removeBand = (i) => setBands((b) => b.filter((_, idx) => idx !== i));

  // Sekme 3 aksiyonları StandTipiKuralTree'de (Global Kurallar ile ortak).

  // ─── Sekme 4 aksiyonları ────────────────────────────────────────────────────
  async function handleAttachForm() {
    const tip = Number(formDraft.formTipi);
    if (tip === 2 && !formDraft.formRef) return;
    if (tip === 3 && !pdfFile) return;

    let formRef = formDraft.formRef;
    if (tip === 3) {
      setPdfUploading(true);
      try {
        const uploaded = await uploadDeclarationFormPdf(pdfFile, { forceLive: isLive });
        formRef = uploaded.fileName;
      } catch (e) {
        setError(e.message);
        setPdfUploading(false);
        return;
      }
      setPdfUploading(false);
    }

    const ok = await runAction(
      () => attachDeclarationForm({ ...formDraft, formRef, fuarId: selectedFuarId }, { forceLive: isLive }),
      "Form beyana eklendi."
    );
    if (ok) { setFormModal(false); setPdfFile(null); }
  }

  // ⚠️ Bu uç PATCH gibi davranır: SADECE değişen bayrağı gönderiyoruz. Tüm nesneyi
  //    göndermek, birinin zorunlu yaptığı formu sessizce isteğe bağlı yapabilir.
  const handleToggleForm = (row, patch, msg) =>
    runAction(() => updateDeclarationForm(row.id, patch, { forceLive: isLive }), msg);

  const handleDetachForm = (row) =>
    runAction(
      () => detachDeclarationForm(row.id, { forceLive: isLive }),
      tx("fuarKurallari.formBeyandanCikarildiGeriEklemek")
    );

  // ─── Backlog #94/#95: "Tüm Beyanlara Uygula" ────────────────────────────────
  async function openApplyFormModal(row) {
    setApplyFormTarget(row);
    setApplyFormModal(true);
    setApplyFormResult(null);
    setApplyFormSebep("");
    setApplyFormPreview(null);
    setApplyFormPreviewLoading(true);
    try {
      const preview = await previewDeclarationFormImpact(row.id, selectedFuarId, { forceLive: isLive });
      setApplyFormPreview(preview);
    } catch (e) {
      setError(e.message);
    } finally {
      setApplyFormPreviewLoading(false);
    }
  }

  // runAction kullanılmıyor: #95 modalın SONUÇ ÖZETİNİ göstererek açık kalmasını istiyor,
  // runAction ise başarıda kapatmayı varsayıyor.
  async function handleApplyFormToAccepted() {
    if (!applyFormTarget) return;
    setActionLoading(true);
    setError(null);
    try {
      const out = await applyDeclarationFormToAccepted(
        applyFormTarget.id, selectedFuarId, applyFormSebep, { forceLive: isLive }
      );
      setApplyFormResult(out);
      setSuccessMsg(out?.message || tx("fuarKurallari.uygulandi"));
      refresh();
    } catch (e) {
      setError(e.message);
    } finally {
      setActionLoading(false);
    }
  }

  // ─── Global şablonu uygula ──────────────────────────────────────────────────
  const handleApplyGlobal = async () => {
    const ok = await runAction(
      () => applyGlobalDefaultsToFuar(selectedFuarId, { overwrite: true, forceLive: isLive }),
      (out) => (out?.applied
        ? tx("fuarKurallari.globalSablonBuFuaraKopyalandi", { bands: out.bands, v: out.kullanimKurallari ?? 0 })
        : out?.reason ?? tx("fuarKurallari.kopyalanacakBirSeyBulunamadi")),
    );
    if (ok) setGlobalModal(false);
  };

  // ─── Backlog #89: named rule-set templates ─────────────────────────────────
  // "kural" sekmesi -> PROJE_KURAL_SETI, "standTipi" sekmesi -> STAND_TIPI_KURALI. Diğer
  // sekmelerde bu düğmeler zaten gösterilmiyor (bkz. aşağıdaki header render'ı).
  const sablonKapsami = activeTab === "standTipi"
    ? KURAL_SETI_SABLON_KAPSAM.STAND_TIPI_KURALI
    : KURAL_SETI_SABLON_KAPSAM.PROJE_KURAL_SETI;

  async function openLoadSablonModal() {
    setLoadSablonModal(true);
    setSelectedSablonId("");
    setSablonlarLoading(true);
    try {
      const list = await listKuralSetiSablonlar(sablonKapsami, { forceLive: isLive });
      setSablonlar(list || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setSablonlarLoading(false);
    }
  }

  const handleSaveSablon = async () => {
    const name = sablonAdi.trim();
    if (!name) return;
    const ok = await runAction(
      () => saveKuralSetiSablon(selectedFuarId, sablonKapsami, name, { forceLive: isLive }),
      tx("fuarKurallari.sablonuKaydedildi", { name })
    );
    if (ok) { setSaveSablonModal(false); setSablonAdi(""); }
  };

  const handleLoadSablon = async () => {
    if (!selectedSablonId) return;
    const chosen = sablonlar.find((s) => String(s.sablonId) === String(selectedSablonId));
    const ok = await runAction(
      () => loadKuralSetiSablon(selectedFuarId, selectedSablonId, { forceLive: isLive }),
      (out) => out?.message || tx("fuarKurallari.sablonuBuFuaraKopyalandi", { v: chosen?.ad ?? "" })
    );
    if (ok) setLoadSablonModal(false);
  };

  // ─── Türetilmiş görünüm değerleri ───────────────────────────────────────────
  const notConfigured = kural?.configured === false;
  // Örnek 30 m²'lik bir stand üzerinden serbest kW önizlemesi — organizatör kademe
  // tablosunun / blok formülünün gerçekte ne verdiğini kaydetmeden görsün.
  // Yalnızca SEÇİLİ modun alanları — "Yok"a geçince eski sabit değer önizlemede kalmasın.
  const previewKural = {
    [SERBEST_KW_MODE.FLAT]: { serbestKw: toNullableNumber(kuralForm.serbestKw) },
    [SERBEST_KW_MODE.BLOCK]: {
      serbestKwBlokKw: toNullableNumber(kuralForm.serbestKwBlokKw),
      serbestKwBlokM2: toNullableNumber(kuralForm.serbestKwBlokM2),
    },
    [SERBEST_KW_MODE.BANDS]: { serbestKwKademeleri: bands },
  }[kwMode] ?? {};
  const freeKwPreview = resolveFreeKw(previewKural, 30);
  const halls = hmax?.halls ?? [];
  // Boş string ile null aynı şeyi ifade ediyor ("kayıt yok"), o yüzden karşılaştırma
  // string üzerinden — 6 ile "6.0" farkı da böylece kirli sayılmıyor.
  const fairLimitDirty = fairLimitInput !== (hmax?.fuarHMax == null ? "" : String(hmax.fuarHMax));
  const zorunluFormCount = beyanFormlari.filter((f) => f.aktif && f.zorunlu).length;
  const brokenFormCount = beyanFormlari.filter((f) => f.aktif && f.formMissing).length;

  if (!selectedFuarId) {
    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={tx("fuarKurallari.fuarKurallari")} pageTitle={tx("fuarKurallari.fuarlar")} />
          <Alert color="secondary">{tx("fuarKurallari.kurallariGormekIcinOnceUst")}</Alert>
        </Container>
      </div>
    );
  }

  // 2026-09-15 sadeleştirme: sekme başına uzun açıklama kartları kaldırıldı. Kuralların
  // gerekçeleri bu dosyanın yorumlarında ve docs/guides/FE-fuar-kural-sistemi-guide.md'de;
  // ekranda yalnızca işlem yapmak için gereken tek satırlık ipuçları kaldı.
  const saveIconBtn = (props) => (
    <Button color="light" className="border" {...props}>
      <Save size={14} />
    </Button>
  );

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("fuarKurallari.fuarKurallari")} pageTitle={tx("fuarKurallari.fuarlar")} />

        {error && (
          <Alert color="danger" toggle={() => { setError(null); setCeilingConflict(null); }}>
            {error}
            {/* 409'un gövdesi engelleyen kayıtları ADLANDIRIR — hatayı eyleme çevirmenin tek yolu. */}
            {ceilingConflict?.length > 0 && (
              <ul className="mb-0 mt-2 small">
                {ceilingConflict.map((c, i) => (
                  <li key={c.salonToFuarId ?? c.fuarId ?? i}>
                    {[
                      c.salonName ?? (c.salonId != null ? `Salon #${c.salonId}` : null),
                      c.fuarName ?? (c.fuarId != null ? `Fuar #${c.fuarId}` : null),
                    ].filter(Boolean).join(" · ")}
                    {" — "}
                    {c.salonHMaxTekKat !== undefined || c.salonHMaxCiftKat !== undefined
                      ? tx("fuarKurallari.tekKatCiftKat", { fmtM: fmtM(c.salonHMaxTekKat), fmtM2: fmtM(c.salonHMaxCiftKat) })
                      : fmtM(c.salonHMax ?? c.fuarHMax)}
                  </li>
                ))}
              </ul>
            )}
          </Alert>
        )}
        {successMsg && <Alert color="success">{successMsg}</Alert>}

        {/* ── Başlık + sekmeler ── */}
        <Card className="mb-3">
          <CardBody className="pb-0">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
              <div>
                <h5 className="mb-0">{selectedFuarName ?? tx("fuarKurallari.fuar", { selectedFuarId })}</h5>
                <span className="text-muted small">
                  #{selectedFuarId} · <Link to="/Management/Fairs" className="text-muted text-decoration-underline">{tx("fuarKurallari.degistir")}</Link>
                </span>
              </div>
              {KURAL_TABS.includes(activeTab) && (
                <div className="d-flex gap-2">
                  {/* Backlog #89: yalnızca Proje Kuralları ve Stand Tipi Kuralları sekmelerinde —
                      Yükseklik Limitleri ve Beyan Formları'nın kendi kapsam kavramı yok. */}
                  {(activeTab === "kural" || activeTab === "standTipi") && (
                    <>
                      <Button color="light" size="sm" className="border" onClick={() => setSaveSablonModal(true)} disabled={loading}>
                        <Save size={14} className="me-1" />{tx("fuarKurallari.sablonOlarakKaydet")}
                      </Button>
                      <Button color="light" size="sm" className="border" onClick={openLoadSablonModal} disabled={loading}>
                        <ClipboardList size={14} className="me-1" />{tx("fuarKurallari.sablonYukle")}
                      </Button>
                    </>
                  )}
                  <Button color="light" size="sm" className="border" onClick={() => setGlobalModal(true)} disabled={loading}>
                    <Globe size={14} className="me-1" />{tx("fuarKurallari.globalSablonuUygula")}
                  </Button>
                  <Button color="light" size="sm" className="border" onClick={refresh} disabled={loading} title={tx("common:yenile")}>
                    <RefreshCw size={14} />
                  </Button>
                </div>
              )}
            </div>
            <Nav tabs className="nav-tabs-custom border-bottom-0">
              {TABS.map((t) => {
                const Icon = t.icon;
                return (
                  <NavItem key={t.key}>
                    <NavLink
                      href="#"
                      className={`fw-semibold ${activeTab === t.key ? "active" : ""}`}
                      onClick={(e) => { e.preventDefault(); setActiveTab(t.key); }}
                    >
                      <Icon size={14} className="me-1" />{t.label}
                      {t.key === "formlar" && brokenFormCount > 0 && (
                        <Badge color="danger" pill className="ms-1">{brokenFormCount}</Badge>
                      )}
                    </NavLink>
                  </NavItem>
                );
              })}
            </Nav>
          </CardBody>
        </Card>

        {loading && KURAL_TABS.includes(activeTab) && (
          <div className="text-center py-5"><Spinner color="primary" /></div>
        )}

        {/* ─────────────── SEKME 1 — YÜKSEKLİK LİMİTLERİ ───────────────
            Çözüm: o kata ait salon limiti → fuar limiti → salonun varsayılanı; varsayılan ve
            fiziksel tavan sonucu kırpar. Varsayılan + tavan burada SALT OKUNUR (Salonlar listesi). */}
        {!loading && activeTab === "hmax" && (
          <>
            <Card>
              <CardHeader className="d-flex align-items-center gap-2">
                <h6 className="card-title mb-0 flex-grow-1">{tx("fuarKurallari.politikaLimitleri")}</h6>
                <span className="text-muted small">{tx("fuarKurallari.bosBirakipKaydetmekLimitiKaldirir")}</span>
              </CardHeader>
              <CardBody>
                <Row className="g-4">
                  <Col md={6}>
                    <Label className="d-flex align-items-center gap-2">
                      {tx("fuarKurallari.fuarYukseklikLimiti")}{" "}<Badge color="primary">{HMAX_SOURCE_LABELS.FAIR}</Badge>
                    </Label>
                    <InputGroup style={{ maxWidth: 280 }}>
                      <Input
                        type="number" min="0" step="0.1" placeholder={tx("fuarKurallari.kayitYok")}
                        value={fairLimitInput} onChange={(e) => setFairLimitInput(e.target.value)}
                      />
                      <InputGroupText>m</InputGroupText>
                      {saveIconBtn({ disabled: actionLoading || !fairLimitDirty, onClick: handleSaveFairLimit })}
                    </InputGroup>
                    {/* WAS: "Bu fuar için izin verilen en yüksek değer." — #48/#49 (2026-09-18):
                        the expo limit no longer blocks anything on its own; it's a bulk-fill tool. */}
                    <div className="text-muted small mt-1">
                      {tx("fuarKurallari.salonDegerleriHerZamanAyri")}
                    </div>
                  </Col>
                  <Col md={6}>
                    <Label className="text-muted">{tx("fuarKurallari.fuarAlani")}</Label>
                    <div className="fw-semibold">{hmax?.fuarAlaniName ?? "—"}</div>
                    <div className="text-muted small mt-1">
                      {tx("fuarKurallari.salonlarinFizikselTavaniVeIzin")}
                      {hmax?.fuarAlaniId != null && (
                        <Link to={`/Management/FairAreas/${hmax.fuarAlaniId}/Salonlar`}>{tx("fuarKurallari.salonlarListesineGit")}</Link>
                      )}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Backlog #157: fuar alanına kayıtlı ama bu fuara henüz bağlanmamış salonlar var —
                bağlama/çıkarma eylemi artık burada değil, "Salonlar ve Krokiler → Salonlar" kendi
                sayfasında (2026-09-23'te taşındı, iki yerde aynı eylemi tekrarlamamak için). Bu
                yalnızca farkındalık + oraya bir link; bkz. yukarıdaki useEffect. */}
            {isLive && !unlinkedLoading && unlinkedHalls.length > 0 && (
              <Alert color="warning" className="d-flex align-items-center gap-3 flex-wrap">
                <div className="flex-grow-1">
                  <span className="fw-semibold">{unlinkedHalls.length}{" "}{tx("fuarKurallari.salon")}</span>{" "}{tx("fuarKurallari.buFuarinFuarAlaninda")}{hmax?.fuarAlaniName ?? "—"}{tx("fuarKurallari.kayitliAmaBuFuaraHenuz")}
                </div>
                <Link to="/Management/Salonlar" className="btn btn-sm btn-warning">
                  {tx("fuarKurallari.salonlarSayfasindaBagla")}
                </Link>
              </Alert>
            )}

            {/* Backlog #86 (Erdinç, confirmed with Deniz, 2026-09-20): reverts #49 — back to ONE
                table with both Tek/Çift columns per row, instead of two separate Card sections.
                There is only one fuar-wide "Fuar yükseklik limiti" (Politika Limitleri card above,
                unchanged), and Bilge's call on where it conceptually sits: the Tek Katlı column.
                #48's bulk-apply still needs to reach either column, so its trigger moves into each
                column's own header instead of a per-section Card header. */}
            {(() => {
              const fairLimitSet = toNullableNumber(fairLimitInput) != null;
              const applyTrigger = (kat) => (
                <Button
                  size="sm" color="primary" outline className="py-0 px-1 lh-1"
                  disabled={actionLoading || !fairLimitSet}
                  title={fairLimitSet
                    ? tx("fuarKurallari.fuarLimitiniTumSalonlarinDegerine", { v: KAT_TIPI_LABELS[kat].toLowerCase() })
                    : tx("fuarKurallari.onceYukaridanBirFuarYukseklik")}
                  onClick={() => setApplyModalKat(kat)}
                >
                  <i className="bx bx-download" />
                </Button>
              );
              return (
                <Card>
                  <CardHeader className="d-flex align-items-center gap-2">
                    <h6 className="card-title mb-0 flex-grow-1">
                      {tx("fuarKurallari.salonLimitleri")}{" "}<Badge color="light" className="text-dark ms-1">{halls.length}</Badge>
                    </h6>
                    <span className="text-muted small">{tx("fuarKurallari.oncelikSalonKataGoreFuar")}</span>
                  </CardHeader>
                  <CardBody className="p-0">
                    {halls.length === 0 ? (
                      <div className="text-muted text-center py-4">{tx("fuarKurallari.buFuaraBagliSalonYok")}</div>
                    ) : (
                      <div className="table-responsive">
                        <Table className="align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              <th className="ps-3">{tx("fuarKurallari.salon2")}</th>
                              <th style={{ width: 170 }}>
                                <div className="d-flex align-items-center gap-1">
                                  {tx("fuarKurallari.tekKatliLimit")}{applyTrigger(KAT_TIPI.TEK_KAT)}
                                </div>
                              </th>
                              <th style={{ width: 170 }}>
                                <div className="d-flex align-items-center gap-1">
                                  {tx("fuarKurallari.ciftKatliLimit")}{applyTrigger(KAT_TIPI.CIFT_KAT)}
                                </div>
                              </th>
                              <th style={{ width: 60 }} />
                              <th style={{ width: 130 }}>{tx("fuarKurallari.izinVerilen")}</th>
                              <th style={{ width: 120 }}>{tx("fuarKurallari.fizikselTavan")}</th>
                              <th>{tx("fuarKurallari.gecerli")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {halls.map((s) => {
                              const input = hallLimitInputs[s.salonToFuarId] ?? { tek: "", cift: "" };
                              const dirty =
                                input.tek !== (s.salonHMaxTekKat == null ? "" : String(s.salonHMaxTekKat))
                                || input.cift !== (s.salonHMaxCiftKat == null ? "" : String(s.salonHMaxCiftKat));
                              const setInput = (key, value) =>
                                setHallLimitInputs((p) => ({ ...p, [s.salonToFuarId]: { ...input, [key]: value } }));
                              return (
                                <tr key={s.salonToFuarId ?? s.salonId}>
                                  <td className="ps-3">
                                    <div className="fw-semibold">{s.salonName ?? tx("fuarKurallari.salon3", { v: s.salonId ?? "?" })}</div>
                                    {s.registeredAtFairground === false && (
                                      <Badge color="light" className="text-warning border" title={tx("fuarKurallari.salonBuFuarAlanininSalonlar")}>
                                        {tx("fuarKurallari.fuarAlanindaKayitliDegil")}
                                      </Badge>
                                    )}
                                  </td>
                                  <td>
                                    <InputGroup size="sm">
                                      <Input
                                        type="number" min="0" step="0.1" placeholder="—"
                                        disabled={s.salonToFuarId == null}
                                        value={input.tek}
                                        onChange={(e) => setInput("tek", e.target.value)}
                                      />
                                      <InputGroupText>m</InputGroupText>
                                    </InputGroup>
                                  </td>
                                  <td>
                                    <InputGroup size="sm">
                                      <Input
                                        type="number" min="0" step="0.1" placeholder="—"
                                        disabled={s.salonToFuarId == null}
                                        value={input.cift}
                                        onChange={(e) => setInput("cift", e.target.value)}
                                      />
                                      <InputGroupText>m</InputGroupText>
                                    </InputGroup>
                                  </td>
                                  <td>
                                    {saveIconBtn({
                                      size: "sm",
                                      disabled: actionLoading || s.salonToFuarId == null || !dirty,
                                      onClick: () => handleSaveHallLimit(s),
                                      title: tx("fuarKurallari.salonLimitleriniKaydet"),
                                    })}
                                  </td>
                                  {/* Salt okunur: fuar alanı → Salonlar listesinde düzenlenir. */}
                                  <td className="text-muted">{fmtM(s.allowedHMax)}</td>
                                  <td className="text-muted">{fmtM(s.ceilingHeight)}</td>
                                  <td>
                                    {[
                                      // WAS: ["Tek kat", s.tekKat],
                                      [tx("fuarKurallari.tekKat"), s.tekKat], // #349
                                      [tx("fuarKurallari.ciftKat"), s.ciftKat],
                                    ].map(([label, r]) => (
                                      <div key={label} className="d-flex align-items-center gap-1 small">
                                        <span className="text-muted" style={{ width: 52 }}>{label}</span>
                                        {r?.hMax == null ? (
                                          <span className="text-muted">{tx("fuarKurallari.kayitYok2")}</span>
                                        ) : (
                                          <>
                                            <span className="fw-semibold">{fmtM(r.hMax)}</span>
                                            <Badge
                                              color={HMAX_SOURCE_COLOR[r.source] ?? "light"}
                                              className={HMAX_SOURCE_COLOR[r.source] === "light" ? "text-dark" : ""}
                                            >
                                              {HMAX_SOURCE_LABELS[r.source] ?? r.source}
                                            </Badge>
                                            {r.clampedByCeiling && (
                                              <Badge color="light" className="text-dark" title={tx("fuarKurallari.politikaLimitiDahaYuksektiSalonun")}>
                                                {tx("fuarKurallari.tavanKirpti")}
                                              </Badge>
                                            )}
                                            {r.clampedByDefault && (
                                              <Badge color="light" className="text-dark" title={tx("fuarKurallari.politikaLimitiDahaYuksektiSalonun2")}>
                                                {tx("fuarKurallari.varsayilanKirpti")}
                                              </Badge>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    ))}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </CardBody>
                </Card>
              );
            })()}
            <div className="text-muted small px-1">
              {tx("fuarKurallari.standTipindeKatBilgisiOlmayan")}
            </div>

            {/* Backlog #48: bulk-apply onayı — hangi kat için açıldığını applyModalKat tutar. */}
            <Modal isOpen={applyModalKat != null} toggle={() => setApplyModalKat(null)}>
              <ModalHeader toggle={() => setApplyModalKat(null)}>
                {tx("fuarKurallari.fuarLimitini")}{" "}{applyModalKat ? KAT_TIPI_LABELS[applyModalKat].toLowerCase() : ""}{" "}{tx("fuarKurallari.salonlaraUygula")}
              </ModalHeader>
              <ModalBody>
                <p>
                  {tx("fuarKurallari.buFuarin")}{" "}<strong>{fmtM(toNullableNumber(fairLimitInput))}</strong>{" "}{tx("fuarKurallari.limitiFuaraBagli")}
                  <strong>{tx("fuarKurallari.herSalonun")}</strong> {applyModalKat ? KAT_TIPI_LABELS[applyModalKat].toLowerCase() : ""}{" "}
                  {tx("fuarKurallari.degerineYazilacakZatenKendiDegeri")}
                </p>
                <p className="text-warning small mb-0 d-flex align-items-start gap-1">
                  <AlertTriangle size={14} className="mt-1 flex-shrink-0" />
                  {tx("fuarKurallari.kabulEdilmisProjeBeyanlariHer")}
                </p>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" outline onClick={() => setApplyModalKat(null)}>{tx("fuarKurallari.vazgec")}</Button>
                <Button color="primary" disabled={actionLoading} onClick={() => handleApplyToHalls(applyModalKat)}>
                  {actionLoading ? <Spinner size="sm" /> : tx("fuarKurallari.uygula")}
                </Button>
              </ModalFooter>
            </Modal>
          </>
        )}

        {/* ─────────────── SEKME 2 — FUAR KURALLARI ───────────────
            PUT /kural TAM DEĞİŞTİRME: form her zaman bütün alanları gönderiyor. */}
        {!loading && activeTab === "kural" && (
          <Card>
            <CardHeader className="d-flex align-items-center gap-2">
              <h6 className="card-title mb-0 flex-grow-1">{tx("fuarKurallari.projeKuralSeti")}</h6>
              {notConfigured
                ? <Badge color="light" className="text-muted border">{tx("fuarKurallari.varsayilanlarGecerli")}</Badge>
                : <Badge color="success-subtle" className="text-success">{tx("fuarKurallari.kayitli")}</Badge>}
            </CardHeader>
            <CardBody>
              {/* ── Serbest elektrik hakkı — tek mod: sabit / matematiksel / kademeli ── */}
              <Row className="g-3 align-items-start">
                <Col md={4}>
                  <div className="fw-semibold">{tx("fuarKurallari.serbestElektrikHakki")}</div>
                  <div className="text-muted small">{tx("fuarKurallari.asilmasiBeyaniEngellemezUyariVerir")}</div>
                </Col>
                <Col md={8}>
                  <ButtonGroup size="sm" className="mb-3">
                    {/* Sıra SERBEST_KW_MODE'un anahtar sırası: Yok / Sabit / Matematiksel / Kademeli. */}
                    {Object.values(SERBEST_KW_MODE).map((m) => (
                      <Button
                        key={m} color="primary" outline={kwMode !== m}
                        onClick={() => setKwMode(m)} title={SERBEST_KW_MODE_LABELS[m]}
                      >
                        {SERBEST_KW_MODE_SHORT_LABELS[m]}
                      </Button>
                    ))}
                  </ButtonGroup>

                  {kwMode === SERBEST_KW_MODE.FLAT && (
                    <InputGroup size="sm" style={{ maxWidth: 220 }}>
                      <Input
                        type="number" min="0" step="0.1" placeholder={tx("fuarKurallari.n0HakYok")}
                        value={kuralForm.serbestKw}
                        onChange={(e) => updateKural("serbestKw", e.target.value)}
                      />
                      <InputGroupText>{tx("fuarKurallari.kW")}</InputGroupText>
                    </InputGroup>
                  )}

                  {/* Matematiksel: floor(m² / blok) × kW — yalnızca tam bloklar. */}
                  {kwMode === SERBEST_KW_MODE.BLOCK && (
                    <>
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        <span>{tx("fuarKurallari.her")}</span>
                        <InputGroup size="sm" style={{ width: 130 }}>
                          <Input
                            type="number" min="0" step="0.5" placeholder="5"
                            value={kuralForm.serbestKwBlokM2}
                            onChange={(e) => updateKural("serbestKwBlokM2", e.target.value)}
                          />
                          <InputGroupText>m²</InputGroupText>
                        </InputGroup>
                        <span>{tx("fuarKurallari.icin2")}</span>
                        <InputGroup size="sm" style={{ width: 130 }}>
                          <Input
                            type="number" min="0" step="0.1" placeholder="2"
                            value={kuralForm.serbestKwBlokKw}
                            onChange={(e) => updateKural("serbestKwBlokKw", e.target.value)}
                          />
                          <InputGroupText>{tx("fuarKurallari.kW")}</InputGroupText>
                        </InputGroup>
                      </div>
                      <div className="text-muted small mt-1">
                        {tx("fuarKurallari.yalnizcaTamBloklarSayilirOrn")}
                      </div>
                      {blokTouched && blokErrors.length > 0 && (
                        <div className="text-danger small mt-2">{blokErrors.join(" · ")}</div>
                      )}
                    </>
                  )}

                  {kwMode === SERBEST_KW_MODE.BANDS && (
                    <>
                      {/* Aralıklar YARI AÇIK [alt, üst): tam 25 m² ikinci kademeye düşer. */}
                      <Table size="sm" className="align-middle mb-2" style={{ maxWidth: 520 }}>
                        <thead className="table-light">
                          <tr>
                            <th>{tx("fuarKurallari.altMDahil")}</th>
                            <th>{tx("fuarKurallari.ustMHaric")}</th>
                            <th>{tx("fuarKurallari.kW")}</th>
                            <th style={{ width: 40 }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {bands.map((b, i) => (
                            // eslint-disable-next-line react/no-array-index-key -- satırların kalıcı id'si yok; PUT tam değiştirme
                            <tr key={i}>
                              <td>
                                <Input type="number" min="0" step="0.5" bsSize="sm" placeholder="0"
                                  value={b.minM2 ?? ""} onChange={(e) => updateBand(i, "minM2", e.target.value)} />
                              </td>
                              <td>
                                <Input type="number" min="0" step="0.5" bsSize="sm" placeholder="∞"
                                  value={b.maxM2 ?? ""} onChange={(e) => updateBand(i, "maxM2", e.target.value)} />
                              </td>
                              <td>
                                <Input type="number" min="0" step="0.5" bsSize="sm"
                                  value={b.serbestKw ?? ""} onChange={(e) => updateBand(i, "serbestKw", e.target.value)} />
                              </td>
                              <td>
                                <Button color="link" size="sm" className="text-danger p-0" onClick={() => removeBand(i)} title={tx("fuarKurallari.kademeyiSil")}>
                                  <Trash2 size={14} />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <Button color="light" size="sm" className="border" onClick={addBand}>
                        <Plus size={13} className="me-1" />{tx("fuarKurallari.kademe")}
                      </Button>
                      {bandErrors.length > 0 && (
                        <div className="text-danger small mt-2">{bandErrors.join(" · ")}</div>
                      )}
                      {/* Üst ucu açık kademe yoksa büyük standlar SESSİZCE hak almaz. */}
                      {bands.length > 0 && !bands.some((b) => b.maxM2 === "" || b.maxM2 == null) && (
                        <div className="text-warning small mt-2">
                          <AlertTriangle size={12} className="me-1" />{tx("fuarKurallari.ustUcuAcikKademeYok")}
                        </div>
                      )}
                    </>
                  )}

                  {freeKwPreview != null && (
                    <div className="text-muted small mt-2">{tx("fuarKurallari.ornek30MKW", { freeKwPreview })}</div>
                  )}
                </Col>
              </Row>

              <hr className="my-4" />

              {/* ── Kullanım kuralları (#53) — katalogdan; "sorulsun" ile "izinli" ayrı sorular ── */}
              <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
                <div className="fw-semibold flex-grow-1">{tx("fuarKurallari.kullanimKurallari")}</div>
                <Link to="/Management/Projects/GlobalRules?tab=kullanim" className="small text-muted text-decoration-underline">
                  {tx("fuarKurallari.tanimlariYonet")}
                </Link>
              </div>
              <KullanimKurallariList
                rules={usageRules} onChange={updateUsageRule} disabled={actionLoading} idPrefix="fk"
              />

              <hr className="my-4" />

              {/* FDS #674 / #675: duvar kuralları — fuara özel değer, boş = kural kapalı. */}
              <DuvarKurallariAlanlari values={kuralForm} onChange={updateKural} disabled={actionLoading} idPrefix="fk" />

              <hr className="my-4" />

              {/* 2026-09-17 (#54): kimlik doğrulama anahtarı ve onay modalı kaldırıldı —
                  artık her fuarda zorunlu, backend alanı yok sayıyor. */}
              <div className="text-muted small d-flex align-items-start gap-1">
                <ShieldCheck size={14} className="flex-shrink-0 mt-1" />
                <span>
                  {tx("fuarKurallari.kimlikDogrulamaArtikFuarKurali")}
                </span>
              </div>
            </CardBody>
            <div className="card-footer d-flex justify-content-end">
              <Button
                color="primary" onClick={handleSaveKural}
                disabled={actionLoading || bandErrors.length > 0 || blokErrors.length > 0}
              >
                {actionLoading ? <Spinner size="sm" className="me-1" /> : <Save size={14} className="me-1" />}
                {tx("common:kaydet")}
              </Button>
            </div>
          </Card>
        )}

        {/* ─────────────── SEKME 3 — STAND TİPİ KURALLARI ───────────────
            Etkin ağaç (#55/#57): her alan önce bu fuarın satırlarından (tip → kök), yoksa global
            (fuar 0) satırlarından. Buradaki H Max ile salon limiti iki ayrı eksen, düşük olan
            uygulanır. Eski düz "kaydedilmiş satırlar" tablosunun yerini aldı. */}
        {!loading && activeTab === "standTipi" && (
          <StandTipiKuralTree
            key={selectedFuarId}
            fuarId={selectedFuarId}
            forceLive={isLive}
            tree={typeTree}
            actionLoading={actionLoading}
            runAction={runAction}
          />
        )}

        {/* ─────────────── SEKME 4 — BEYAN FORMLARI ───────────────
            Zorunlu form beyanı değil KABULÜ (Sistemi Onayla) engeller. */}
        {!loading && activeTab === "formlar" && (
          <Card>
            <CardHeader className="d-flex align-items-center gap-2">
              <h6 className="card-title mb-0 flex-grow-1">
                {tx("fuarKurallari.ekFormlar")}
                <Badge color="light" className="text-dark ms-1">{beyanFormlari.filter((f) => f.aktif).length}</Badge>
                {zorunluFormCount > 0 && <Badge color="danger-subtle" className="text-danger ms-1">{zorunluFormCount}{" "}{tx("fuarKurallari.zorunlu")}</Badge>}
              </h6>
              <Button
                color="primary" size="sm"
                onClick={() => { setFormDraft({ formTipi: 1, formRef: "", zorunlu: false, sira: beyanFormlari.length + 1 }); setPdfFile(null); setFormModal(true); }}
              >
                <Plus size={14} className="me-1" />{tx("fuarKurallari.formEkle")}
              </Button>
            </CardHeader>
            <CardBody className="p-0">
              {brokenFormCount > 0 && (
                <Alert color="danger" className="small rounded-0 mb-0 border-0">
                  <AlertTriangle size={14} className="me-1" />
                  {tx("fuarKurallari.formunTanimiBulunamiyorZorunluysaHicbir", { brokenFormCount })}
                </Alert>
              )}
              {beyanFormlari.length === 0 ? (
                <div className="text-muted text-center py-4">{tx("fuarKurallari.ekFormYokStandartProje")}</div>
              ) : (
                <div className="table-responsive">
                  <Table className="align-middle table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="ps-3" style={{ width: 70 }}>{tx("fuarKurallari.sira")}</th>
                        <th>{tx("fuarKurallari.form")}</th>
                        <th style={{ width: 170 }}>{tx("fuarKurallari.tip")}</th>
                        <th style={{ width: 100 }}>{tx("fuarKurallari.zorunlu2")}</th>
                        <th style={{ width: 120 }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {beyanFormlari.map((f) => (
                        <tr key={f.id} className={f.aktif ? "" : "opacity-50"}>
                          <td className="ps-3 text-muted">{f.sira}</td>
                          <td>
                            {f.formTipi === 3 && f.formUrl ? (
                              <a href={f.formUrl} target="_blank" rel="noreferrer" className="fw-semibold">
                                {f.formAdi ?? tx("fuarKurallari.pdf")} <i className="bx bx-download ms-1" />
                              </a>
                            ) : (
                              <span className="fw-semibold">{f.formAdi ?? `#${f.id}`}</span>
                            )}
                            {/* formMissing satırları GİZLENMEZ, KIRIK gösterilir. */}
                            {f.formMissing && <Badge color="danger" className="ms-2">{tx("fuarKurallari.tanimYok")}</Badge>}
                            {!f.aktif && <Badge color="light" className="text-muted ms-2">{tx("fuarKurallari.cikarildi")}</Badge>}
                          </td>
                          <td>
                            <Badge color={BEYAN_FORM_TIPI[f.formTipi]?.color ?? "secondary"}>
                              {f.formTipiAdi ?? BEYAN_FORM_TIPI[f.formTipi]?.label ?? `#${f.formTipi}`}
                            </Badge>
                          </td>
                          <td>
                            <FormGroup switch className="mb-0">
                              <Input
                                type="switch" role="switch" checked={Boolean(f.zorunlu)}
                                disabled={actionLoading || !f.aktif}
                                onChange={(e) => handleToggleForm(
                                  f, { zorunlu: e.target.checked },
                                  e.target.checked ? tx("fuarKurallari.formZorunluYapildi") : tx("fuarKurallari.formIstegeBagliYapildi")
                                )}
                              />
                            </FormGroup>
                          </td>
                          <td className="text-end pe-3">
                            {f.aktif && (
                              <Button
                                color="link" size="sm" className="text-body p-1" disabled={actionLoading}
                                title={tx("fuarKurallari.tumBeyanlaraUygulaBuFormu")}
                                onClick={() => openApplyFormModal(f)}
                              >
                                <RotateCcw size={14} />
                              </Button>
                            )}
                            {f.aktif ? (
                              <Button color="link" size="sm" className="text-danger p-1" disabled={actionLoading} onClick={() => handleDetachForm(f)}>
                                {tx("fuarKurallari.cikar")}
                              </Button>
                            ) : (
                              // "Geri ekle" = PUT {aktif:true}; yeniden POST zorunlu/sıra bayraklarını ezerdi.
                              <Button
                                color="link" size="sm" className="text-success p-1" disabled={actionLoading}
                                onClick={() => handleToggleForm(f, { aktif: true }, "Form geri eklendi.")}
                              >
                                {tx("fuarKurallari.geriEkle")}
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </CardBody>
            <div className="card-footer text-muted small">{tx("fuarKurallari.zorunluFormlarDoldurulmadanBeyanOnaylanamaz")}</div>
          </Card>
        )}

        {/* ─────────────── SEKME 5 — BELGE KURALLARI ───────────────
            Gömülü BelgeKurallariPage, kapsam "fuar"a SABİT — globale buradan yazılamaz. */}
        {activeTab === "belge" && <BelgeKurallariPage scope="fuar" embedded />}

        {/* #430: the company document rules by nationality for THIS fair (the global level is Global Kurallar's, shown read-only inside). */}
        {activeTab === "firmaBelge" && <FirmaBelgeKurallariKarti key={selectedFuarId} fuarId={Number(selectedFuarId)} />}

        {/* #374: PPE (KKD) for THIS fair. The item catalogue and the global template are Global Kurallar's (linked from inside). */}
        {activeTab === "kkd" && <KkdKurallariKarti key={selectedFuarId} fuarId={Number(selectedFuarId)} />}

        {/* ─────────────── SEKME 6 — TALEP TÜRLERİ ───────────────
            stand_job_type_to_fuar — canlı, her fuar için (298/299 köprüsüne tabi değil). */}
        {activeTab === "talep" && <FuarTalepTurleriTab key={selectedFuarId} fuarId={selectedFuarId} />}

        {/* Serbest metin alan uyarıları — eski /Management/Projects/DeclarationWarnings. */}
        {activeTab === "uyari" && <ProjeBeyaniUyarilariTab key={selectedFuarId} fuarId={selectedFuarId} />}

        {/* Stand tipi kuralı ekle/düzenle/kaldır modalları StandTipiKuralTree'nin içinde.
            Kimlik doğrulama onay modalı 2026-09-17'de (#54) kaldırıldı. */}

        {/* ─── Beyan formu ekle ─── */}
        <Modal isOpen={formModal} toggle={() => !actionLoading && setFormModal(false)} centered>
          <ModalHeader toggle={() => !actionLoading && setFormModal(false)}>{tx("fuarKurallari.formEkle")}</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label size="sm">{tx("fuarKurallari.tip")}</Label>
              <Input
                type="select" bsSize="sm" value={formDraft.formTipi}
                onChange={(e) => { setFormDraft((f) => ({ ...f, formTipi: Number(e.target.value), formRef: "" })); setPdfFile(null); }}
              >
                <option value={1}>{BEYAN_FORM_TIPI[1].label}</option>
                <option value={2}>{BEYAN_FORM_TIPI[2].label}</option>
                <option value={3}>{BEYAN_FORM_TIPI[3].label}</option>
              </Input>
            </FormGroup>
            {Number(formDraft.formTipi) === 2 && (
              <FormGroup>
                {/* Yalnızca STAND hedefli şablonlar beyana takılabilir. */}
                <Label size="sm">{tx("fuarKurallari.sablon")}{" "}<span className="text-muted fw-normal">{tx("fuarKurallari.standHedefli")}</span></Label>
                <Input
                  type="select" bsSize="sm" value={formDraft.formRef}
                  onChange={(e) => setFormDraft((f) => ({ ...f, formRef: e.target.value }))}
                >
                  <option value="">{tx("fuarKurallari.secin")}</option>
                  {standTemplates.map((t) => (
                    <option key={t._id ?? t.id} value={t._id ?? t.id}>{t.name}</option>
                  ))}
                </Input>
              </FormGroup>
            )}
            {Number(formDraft.formTipi) === 3 && (
              <FormGroup>
                <Label size="sm">{tx("fuarKurallari.pdfDosyasi")}</Label>
                <Input
                  type="file" bsSize="sm" accept="application/pdf,.pdf"
                  onChange={(e) => setPdfFile(e.target.files?.[0] ?? null)}
                />
                <div className="text-muted small mt-1">
                  {tx("fuarKurallari.enFazla15MbBilgilendirme")}
                </div>
              </FormGroup>
            )}
            <Row className="g-3 align-items-end">
              <Col xs={6}>
                <Label size="sm">{tx("fuarKurallari.sira")}</Label>
                <Input type="number" min="0" bsSize="sm" value={formDraft.sira}
                  onChange={(e) => setFormDraft((f) => ({ ...f, sira: e.target.value }))} />
              </Col>
              <Col xs={6}>
                <FormGroup switch className="mb-1">
                  <Input type="switch" role="switch" id="form-zorunlu" checked={formDraft.zorunlu}
                    onChange={(e) => setFormDraft((f) => ({ ...f, zorunlu: e.target.checked }))} />
                  <Label check for="form-zorunlu">{tx("fuarKurallari.zorunlu2")}</Label>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={() => setFormModal(false)} disabled={actionLoading || pdfUploading}>{tx("fuarKurallari.vazgec")}</Button>
            <Button
              color="primary" onClick={handleAttachForm}
              disabled={actionLoading || pdfUploading
                || (Number(formDraft.formTipi) === 2 && !formDraft.formRef)
                || (Number(formDraft.formTipi) === 3 && !pdfFile)}
            >
              {(actionLoading || pdfUploading) ? <Spinner size="sm" className="me-1" /> : <Plus size={14} className="me-1" />}{tx("common:ekle")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* ─── Backlog #94/#95: Tüm Beyanlara Uygula ───
            Önizleme (kaç beyan etkilenecek) -> onay -> sonuç özeti, aynı modalda. Sessiz bir
            işlem değil: kabul edilmiş beyanların sistem atamasını geri alır. */}
        <Modal isOpen={applyFormModal} toggle={() => !actionLoading && setApplyFormModal(false)} centered>
          <ModalHeader toggle={() => !actionLoading && setApplyFormModal(false)}>
            {tx("fuarKurallari.tumBeyanlaraUygula")}{" "}{applyFormTarget?.formAdi ?? applyFormTarget?.formTipiAdi ?? tx("fuarKurallari.form")}
          </ModalHeader>
          <ModalBody>
            {applyFormResult ? (
              <>
                <Alert color={(applyFormResult.data?.length ?? 0) > 0 ? "success" : "secondary"} className="mb-2">
                  {applyFormResult.message}
                </Alert>
                {(applyFormResult.data?.length ?? 0) > 0 && (
                  <ul className="small mb-0" style={{ maxHeight: 220, overflowY: "auto" }}>
                    {applyFormResult.data.map((p) => (
                      <li key={p.id}>{p.standName ?? tx("fuarKurallari.stand", { standId: p.standId })} — {p.firmaName ?? "—"}</li>
                    ))}
                  </ul>
                )}
              </>
            ) : applyFormPreviewLoading ? (
              <div className="text-center py-3"><Spinner size="sm" /></div>
            ) : (
              <>
                <p className="mb-2">
                  <strong>{applyFormPreview?.count ?? 0}</strong>{" "}{tx("fuarKurallari.kabulEdilmisBeyanBuFormu")}
                </p>
                {(applyFormPreview?.count ?? 0) > 0 && (
                  <>
                    <ul className="small" style={{ maxHeight: 180, overflowY: "auto" }}>
                      {(applyFormPreview?.projects ?? []).map((p) => (
                        <li key={p.id}>{p.standName ?? tx("fuarKurallari.stand", { standId: p.standId })} — {p.firmaName ?? "—"}</li>
                      ))}
                    </ul>
                    <p className="text-danger small d-flex align-items-start gap-1 mb-2">
                      <AlertTriangle size={14} className="mt-1 flex-shrink-0" />
                      {tx("fuarKurallari.buYukaridakiBeyanlarinKabulunuGeri")}
                    </p>
                    <FormGroup className="mb-0">
                      <Label size="sm">{tx("fuarKurallari.sebep")}{" "}<span className="text-muted fw-normal">{tx("fuarKurallari.opsiyonel")}</span></Label>
                      <Input
                        size="sm" value={applyFormSebep} onChange={(e) => setApplyFormSebep(e.target.value)}
                        placeholder={tx("fuarKurallari.ornYeniZorunluFormEklendi")}
                      />
                    </FormGroup>
                  </>
                )}
              </>
            )}
          </ModalBody>
          <ModalFooter>
            {applyFormResult ? (
              <Button color="light" onClick={() => setApplyFormModal(false)}>{tx("common:kapat")}</Button>
            ) : (
              <>
                <Button color="light" onClick={() => setApplyFormModal(false)} disabled={actionLoading}>{tx("fuarKurallari.vazgec")}</Button>
                <Button
                  color="danger" onClick={handleApplyFormToAccepted}
                  disabled={actionLoading || applyFormPreviewLoading || (applyFormPreview?.count ?? 0) === 0}
                >
                  {actionLoading ? <Spinner size="sm" className="me-1" /> : <AlertTriangle size={14} className="me-1" />}
                  {tx("fuarKurallari.beyaniGeriAl", { v: applyFormPreview?.count ?? 0 })}
                </Button>
              </>
            )}
          </ModalFooter>
        </Modal>

        {/* ─── Global şablonu uygula — KOPYA, miras değil; mevcut kurallar ezilir ───
            2026-09-17: stand tipi kuralları artık kopyalanmıyor (canlı miras, #55/#57). */}
        <Modal isOpen={globalModal} toggle={() => !actionLoading && setGlobalModal(false)} centered>
          <ModalHeader toggle={() => !actionLoading && setGlobalModal(false)}>{tx("fuarKurallari.globalSablonuUygula2")}</ModalHeader>
          <ModalBody>
            <p className="mb-2">
              {tx("fuarKurallari.globalSerbestElektrikAyariKademeler")}
              <span className="fw-semibold">{tx("fuarKurallari.kopyalanacak")}</span>{tx("fuarKurallari.mevcutlarinUzerineYazilir")}
            </p>
            <p className="text-muted small mb-2">{tx("fuarKurallari.kopyadanSonraBuAyarlardakiGlobal")}</p>
            <p className="text-muted small mb-0">
              {tx("fuarKurallari.standTipiKurallari2")}{" "}<span className="fw-semibold">{tx("fuarKurallari.kopyalanmaz")}</span>{tx("fuarKurallari.buFuarOnlariGlobalKurallardan")}
            </p>
          </ModalBody>
          <ModalFooter>
            <Link to="/Management/Projects/GlobalRules" className="btn btn-link btn-sm me-auto">{tx("fuarKurallari.sablonuDuzenle")}</Link>
            <Button color="light" onClick={() => setGlobalModal(false)} disabled={actionLoading}>{tx("fuarKurallari.vazgec")}</Button>
            <Button color="primary" onClick={handleApplyGlobal} disabled={actionLoading}>
              {actionLoading ? <Spinner size="sm" className="me-1" /> : <Globe size={14} className="me-1" />}{tx("fuarKurallari.kopyala")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* ─── Backlog #89: şablon olarak kaydet ───
            Bu fuarın SEÇİLİ SEKME için o anki hâlini adlandırıp kaydeder. Değer okuma yok —
            kaydetme backend'de bu fuarın güncel verisinden yapılıyor. */}
        <Modal isOpen={saveSablonModal} toggle={() => { if (!actionLoading) { setSaveSablonModal(false); setSablonAdi(""); } }} centered>
          <ModalHeader toggle={() => { if (!actionLoading) { setSaveSablonModal(false); setSablonAdi(""); } }}>
            {tx("fuarKurallari.sablonOlarakKaydet2")}
          </ModalHeader>
          <ModalBody>
            <p className="text-muted small mb-3">
              {sablonKapsami === KURAL_SETI_SABLON_KAPSAM.STAND_TIPI_KURALI
                ? tx("fuarKurallari.buFuarinStandTipiKurallari")
                : tx("fuarKurallari.buFuarinSerbestKWAyari")}
            </p>
            <FormGroup className="mb-0">
              <Label size="sm">{tx("fuarKurallari.sablonAdi")}</Label>
              <Input
                autoFocus value={sablonAdi} onChange={(e) => setSablonAdi(e.target.value)}
                placeholder={tx("fuarKurallari.ornStandartElektronikFuariKurallari")}
                onKeyDown={(e) => { if (e.key === "Enter" && sablonAdi.trim()) handleSaveSablon(); }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={() => { setSaveSablonModal(false); setSablonAdi(""); }} disabled={actionLoading}>{tx("fuarKurallari.vazgec")}</Button>
            <Button color="primary" onClick={handleSaveSablon} disabled={actionLoading || !sablonAdi.trim()}>
              {actionLoading ? <Spinner size="sm" className="me-1" /> : <Save size={14} className="me-1" />}{tx("common:kaydet")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* ─── Backlog #89: şablon yükle — KOPYADIR, seçili sekmenin mevcut değerlerinin
            üzerine yazar. Global Şablonu Uygula modalıyla aynı uyarı kalıbı. ─── */}
        <Modal isOpen={loadSablonModal} toggle={() => !actionLoading && setLoadSablonModal(false)} centered>
          <ModalHeader toggle={() => !actionLoading && setLoadSablonModal(false)}>{tx("fuarKurallari.sablonYukle2")}</ModalHeader>
          <ModalBody>
            {sablonlarLoading ? (
              <div className="text-center py-3"><Spinner size="sm" /></div>
            ) : sablonlar.length === 0 ? (
              <div className="text-muted small">
                {sablonKapsami === KURAL_SETI_SABLON_KAPSAM.STAND_TIPI_KURALI
                  ? tx("fuarKurallari.kayitliStandTipiKurallariSablonu")
                  : tx("fuarKurallari.kayitliProjeKuralSetiSablonu")}
              </div>
            ) : (
              <>
                <FormGroup>
                  <Label size="sm">{tx("fuarKurallari.sablon")}</Label>
                  <Input
                    type="select" value={selectedSablonId}
                    onChange={(e) => setSelectedSablonId(e.target.value)}
                  >
                    <option value="">{tx("fuarKurallari.secin")}</option>
                    {sablonlar.map((s) => (
                      <option key={s.sablonId} value={s.sablonId}>{s.ad}</option>
                    ))}
                  </Input>
                </FormGroup>
                <p className="text-warning small mb-0 d-flex align-items-start gap-1">
                  <AlertTriangle size={14} className="mt-1 flex-shrink-0" />
                  {tx("fuarKurallari.yuklemekBuFuarin")}{" "}{sablonKapsami === KURAL_SETI_SABLON_KAPSAM.STAND_TIPI_KURALI
                    ? tx("fuarKurallari.standTipiKurallarinin")
                    : tx("fuarKurallari.serbestKWAyarininKademelerininVe")}{" "}
                  {tx("fuarKurallari.uzerineKopyalarOlarakYazarMevcut")}
                </p>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={() => setLoadSablonModal(false)} disabled={actionLoading}>{tx("fuarKurallari.vazgec")}</Button>
            <Button color="primary" onClick={handleLoadSablon} disabled={actionLoading || !selectedSablonId}>
              {actionLoading ? <Spinner size="sm" className="me-1" /> : <ClipboardList size={14} className="me-1" />}{tx("fuarKurallari.yukle")}
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
}
